import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class gp_sheet_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected segmentsFilter : multipleSelector_template;
    protected countriesFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    protected exportDailyDataCsv: exportDataCsv;

    public l3dSessionsTooltip: infoButton_template;
    public l7dSessionsTooltip: infoButton_template;
    public l30dSessionsTooltip: infoButton_template;

    public displayFillrateTooltip: infoButton_template;
    public videoFillrateTooltip: infoButton_template;
    public signUpRatioTooltip: infoButton_template;
    public suspiciousTrafficExclusionsTooltip: infoButton_template;

    readonly trafficTypeFiltersList = [
        { "id": 'all', "name": "All"},
        { "id": 1, "name": "amp"},
        { "id": 0, "name": "non-amp"}
    ];

    readonly viewModes = [
        { "id": "daily", "name": "daily"},
        { "id": "brands", "name": "brands"},
        { "id": "segments", "name": "segments"},
        { "id": "templates", "name": "templates"},
        { "id": "advertisers", "name": "advertisers"},
        { "id": "zones", "name": "zones"}
    ];

    readonly intentGrouping = [
        { "id": "all", "name": "All"},
        { "id": "commerce", "name": "commerce"},
        { "id": "non-commerce", "name": "non-commerce"}
    ];

    readonly organicSegments =      [
        'FB-P',
        'organic',
        'Instant Article',
        'balance',
        'NewsBreak'

    ];

    readonly revenueOptions = [
        { "id": "total_rev", "name": "Total Revenue"},
        { "id": "rpm_count", "name": "RPM Contribution"},
        { "id": "rev_percentage", "name": "Revenue %"},
        { "id": "inventory", "name": "Inventory"},
        { "id": "inv_percentage", "name": "Inventory %"}
    ];

    readonly displayModes = [
        { "id": "date", "name": "Date"},
        { "id": "month", "name": "Month"},
    ];

    readonly deviceOptions = [
        { "id": "all", "name": "All"},
        { "id": "mobile", "name": "Mobile"},
        { "id": "desktop", "name": "Desktop"},
    ];

    readonly mobileOsOptions = [
        { "id": "Android", "name": "Android" },
        { "id": "iOS", "name": "iOS" }
    ]

    readonly directAdvertiserNamesArray = [
        "ADAGIO_PB",
        "AMAZON HB",
        "AOL",
        "APPNEXUS_PB",
        "AVANTIS DIRECT",
        "CONSUMABLE_PB",
        "INDEX_PB",
        "INFOLINKS",
        "KARGO_PB",
        "NEXTMILLENNIUM_PB",
        "PUBMATIC_PB",
        "RUBICON",
        "TEADS_PB",
        "TRIPLELIFT_PB",
        "UNDERTONE_PB",
        "VIDAZOO_PB"
    ]

    protected getTemplateHtml(): string{

        let myThis = this;
        return   /*html*/`
            <div class="sub-header w-justify">

                ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">

                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelected"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                         </div>

                         <!-- ko ifnot: viewModeSelected() == 'brands' -->
                         <div class="dropdown select-single">
                            <label class="form-label" for="">Display Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: displayModeSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: displayModeOptions">
                                        <input type="radio" data-bind="checked : $parent.displayModeSelected, value: id,  attr: { 'id': 'display_' + id, 'name' : 'display_' + id }, event:{ change: $parent.onDisplayModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'display_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                         </div>
                         <!-- /ko -->

                         <div class="dropdown select-single">
                            <label class="form-label" for="">Revenue Options</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: revenueOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: revenueOptions">
                                        <input type="radio" data-bind="checked : $parent.revenueOptionSelected, value: id,  attr: { 'id': 'revenue_' + id, 'name' : 'revenue_' + id }, event:{ change: $parent.onRevenueOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'revenue_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                         </div>
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Traffic Type</label>
                            <button class="dropdown-toggle " type="button" data-bind="text: trafficTypeSelectedText"></button>
                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: trafficTypes">
                                        <input type="radio" data-bind="checked : $parent.trafficTypeSelected, value: id,  attr: { 'id': 'traffic_' + id, 'name' : 'traffic_' + id }, event:{ change: $parent.onTrafficTypeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'traffic_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                         </div>

                         ${this.brandsFilter.getHtmlBuild()}
                         ${this.segmentsFilter.getHtmlBuild()}

                        <div class="dropdown select-single">
                        <label class="form-label" for="">Intent Grouping</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: intentGroupingSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: intentGroupings">
                                        <input type="radio" data-bind="checked : $parent.intentGroupingSelected, value: id,  attr: { 'id': 'intent_' + id, 'name' : 'intent_' + id }, event:{ change: $parent.onIntentGroupingChange}">
                                        <label class="form-label" data-bind="attr: {for : 'intent_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                        </div>

                         ${this.countriesFilter.getHtmlBuild()}
                         <!--
                         <div class="dropdown">
                            <button class="dropdown-toggle " type="button" data-bind="css: { 'is-selected': selectedTemplateFilter }">Segments</button>

                            <div class="dropdown-list">

                                <div class="w-form w-form-segments">
                                    <div class="w-form-group" data-bind="foreach: segmentGroups">
                                        <div>
                                            <div class="form-group">
                                                <strong class="form-title" data-bind="text: name"></strong>
                                            </div>
                                            <div class="form-group" data-bind="foreach: items">
                                                <input type="checkbox" data-bind="checked : $parent.selectedItems, value: id,  attr: { 'id': 'segment_' + id, 'name' : 'segment_' + id }, event:{ change: $parents[1].onSegmentSelected}"">
                                                <label class="form-label" data-bind="attr: {for : 'segment_' + id }, text: name"></label>
                                            </div>

                                            <div class="form-group row">
                                                <button class="btn small" type="button" data-bind="text: 'Select All ' + name, event: { click: $parent.onSelectAllSegmentsInGroup}"></button>
                                                <button class="btn small" type="button" data-bind="text: 'Deselect All ' + name, event: { click: $parent.onDeselectAllSegmentsInGroup}"></button>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="form-footer">
                                        <button class="btn" type="button" data-bind="event: { click: onSelectAllPaidSegments}">Select All Paid</button>
                                        <button class="btn" type="button" data-bind="event: { click: onDeselectAllSegments}">Deselect All</button>
                                    </div>

                                </div>

                            </div>

                         </div>
                         -->


                        <div class="dropdown select-single">
                        <label class="form-label" for="">Device Options</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: deviceOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: deviceOptions">
                                        <input type="radio" data-bind="checked : $parent.deviceOptionSelected, value: id,  attr: { 'id': 'device_' + id, 'name' : 'device_' + id }, event:{ change: $parent.onDeviceOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'device_' + id }, text: name"></label>
                                        <!-- ko if: id == 'mobile' -->
                                            <div class="form-group" data-bind="foreach: $parents[0].mobileOsOptions">
                                                <input type="radio" data-bind="checked : $parents[1].mobileOsOptionSelected, value: id,  attr: { 'id': 'mobileOs_' + id, 'name' : 'mobileOs_' + id }, event:{ change: $parents[1].onMobileOsOptionChange}">
                                                <label class="form-label" data-bind="attr: {for : 'mobileOs_' + id }, text: name"></label>
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="dropdown  select-single">
                                <label class="form-label" for="">Templates</label>
                                <button class="dropdown-toggle " type="button" data-bind="css: { 'is-selected': selectedTemplateFilter }, text: selectedTemplateFilterText"></button>
                                <div class="dropdown-list" style="max-height: 34rem;overflow: scroll;transform: translateX(-50%);">
                                    <div class="w-form w-form-templates">
                                        <div class="w-form-group border" style="margin-bottom: 0rem">
                                            <div class="form-group" data-bind="foreach: allTemplates">
                                                <input type="radio" data-bind="checked : $parent.templateSelected, value: id,  attr: { 'id': 'template_' + id, 'name' : 'template_' + id }, event:{ change: $parent.onTemplateChange}">
                                                <label class="form-label" data-bind="attr: {for : 'template_' + id }, text: displayedName"></label>
                                            </div>
                                        </div>
                                        <div class="w-form-group border" style="gap: 1rem; padding:0 1rem">
                                            <div style="border-right: 1px solid rgba(54, 72, 96, 0.15);">
                                                <span class="form-label" style="margin: 1.5rem 2rem;">Active</span>
                                                <div class="form-group" data-bind="foreach: activeTemplates">
                                                    <input type="radio" data-bind="checked : $parent.templateSelected, value: name,  attr: { 'id': 'template_' + id, 'name' : 'template_' + id }, event:{ change: $parent.onTemplateChange}">
                                                    <label style="margin-left: 0" class="form-label" data-bind="attr: {for : 'template_' + id }, text: displayedName"></label>
                                                </div>
                                            </div>
                                            <div>
                                                <span class="form-label" style="margin: 1.5rem 2rem;">legacy</span>
                                                <div class="form-group" data-bind="foreach: legacyTemplates">
                                                    <input type="radio" data-bind="checked : $parent.templateSelected, value: name,  attr: { 'id': 'template_' + id, 'name' : 'template_' + id }, event:{ change: $parent.onTemplateChange}">
                                                    <label style="margin-left: 0" class="form-label" data-bind="attr: {for : 'template_' + id }, text: displayedName"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                         </div>



                         ${this.datesFilter.getHtmlBuild()}


                    </div>



            </div>

            ${this.validationsList.getHtmlBuild() }

             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-segments"></div>
                    <div id="selected-countries"></div>
                    <div id="selected-templates"></div>
                </div>
            </div>

            <div class="list-header w-justify">

                <div class="w-left">

                    <h2 class="section-title icon">Revenue Sheet</h2>
                    <div>
                        <label class="toggle">
                            <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                            <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                            <div class="toggle-switch"></div>
                            <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                        </label>
                    </div>


                    <div class="w-calculating" data-bind="visible:gpAggInProgress().length">
                        <div class="w-title">
                            <h3 class="icon i-settings">calculating...</h3>
                        </div>
                        <div class="calculating" data-bind="foreach: gpAggInProgress">
                            <div><strong data-bind="text:brand"></strong><span data-bind="text:date"></span></div>
                        </div>
                        <div class="alert icon done">
                            <p>Updated data is being inserted.<br />Please refresh.</p>
                        </div>
                    </div>

                </div>
                <div class="w-right w-dropdown-status">

                    <!-- ko if: viewModeSelected() == 'zones' -->
                        <div>
                            <label class="toggle">
                                <span class="toggle-label" data-bind="css: (zonesModeGrouping() == 'daily') ? 'is-activated' : ''">Daily</span>
                                <input class="toggle-checkbox" data-bind="event: {change: onToggleZonesModeGrouping}, checked: (zonesModeGrouping() == 'brands')" type="checkbox">
                                <div class="toggle-switch"></div>
                                <span class="toggle-label" data-bind="css: (zonesModeGrouping() == 'brands') ? 'is-activated' : ''">Brands</span>
                            </label>
                        </div>
                    <!-- /ko -->

                    <!-- ko if: trafficSource() == 2 && canManageSuspiciousTrafficExclusions() -->
                    <button class="btn icon highlight i-settings traffic-settings-button" type="button" data-bind="click: openSuspiciousTrafficSettings">Traffic Settings</button>
                    <!-- /ko -->

                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': viewModeSelected() != 'daily' && viewModeSelected() != 'brands' && viewModeSelected() != 'advertisers' }">Export</button>

                    <!-- ko if: showSimplifyButton() -->
                        <button class="btn highlight icon fix-width i-expand" type="button" data-bind= "css: colapsButtonClass(), text: colapsButtonText(), event: { click: onColapseYieldRevenue}">Simplify</button>
                    <!-- /ko -->

                    <!-- ko if: showSimplifyVideoRPMButton() -->
                        <button class="btn highlight icon fix-width i-expand" type="button" data-bind= "css: colapsVideoRPMButtonClass(), text: colapsVideoRPMButtonText(), event: { click: onColapseVideoRPM}">Simplify</button>
                    <!-- /ko -->

                    <button class="btn icon highlight i-refresh" type="button" data-bind="event: { click: refreshData}">Refresh</button>
                </div>
            </div>

            <div id="list-results" style="position: relative">

            <div class="w-sticky-col">

                <table class="list-results list-sections" >
                    <thead>

                        <!-- ko ifnot: viewModeSelected() == 'zones' -->

                            <!-- ko ifnot: viewModeSelected() == 'daily' -->
                            <tr class="list-header-section">
                                <!-- ko ifnot: hasPortfolioHeaders() -->
                                    <!-- ko if: viewModeSelected() == 'advertisers' -->
                                        <th class="section-1" style="border-right: 1px solid #d3d3d3;" data-bind="attr: { colspan: (revenueColumnsNumber() + 3) }"><span data-bind="text: viewModeSelected"></span></th>
                                        <th class="section-1" colspan="1"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                    <!-- /ko -->

                                    <!-- ko ifnot: viewModeSelected() == 'advertisers' -->
                                        <th class="section-1" style="border-right: 1px solid #d3d3d3;" data-bind="attr: { colspan: revenueHeaders().length + 1 }"><span data-bind="text: viewModeSelected"></span></th>

                                        <!-- ko if: showRevenueBreakdown() -->
                                            <th class="section-1" data-bind="attr: { colspan: (colapsVideoRPMButtonText() == 'expand') ? 8 : 12}"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                        <!-- /ko -->

                                        <!-- ko ifnot: showRevenueBreakdown() -->

                                            <th class="section-1" colspan="1"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                <!-- /ko -->


                                    <!-- ko if: viewModeSelected() == 'brands' -->
                                        <!-- ko if: showRevenueBreakdown() -->
                                            <th class="section-1" data-bind="attr: { colspan: (colapsVideoRPMButtonText() == 'expand') ? 10 : 14}"><span>Total Revenue</span></th>
                                        <!-- /ko -->

                                        <!-- ko ifnot: showRevenueBreakdown() -->
                                            <th class="section-1" colspan="2"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                        <!-- /ko -->
                                    <!-- /ko -->


                                    <!-- ko ifnot: viewModeSelected() == 'advertisers' -->
                                        <!-- <th class="section-2"><span>Programmatic Revenue</span></th>
                                        <th class="section-2"><span>Affiliate Revenue</span></th>
                                        <th class="section-2"><span>Direct Revenue</span></th>
                                        <th class="section-2"><span>Sponsored Revenue</span></th> -->
                                    <!-- /ko -->




                                <!-- ko if: viewModeSelected() != 'advertisers' -->

                                        <th data-bind="attr: { colspan: rpmColumnsNumber(), class: (trafficSource() == 2) ? 'colgroup-4 end start' : 'section-4'}"><span>RPM</span></th>

                                        <th data-bind="attr: { colspan: cpmColumnsNumber(), class: (trafficSource() == 2) ? 'colgroup-4 end start' : 'section-4'}"><span>CPM</span></th>

                                        <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="2"><span>SV</span></th>

                                        <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end expanded-cells' : 'section-4 expanded-cells', colspan: trafficColumnsNumber()}"><span>Traffic</span></th>
                                        <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4', colspan: (colapsVideoRPMButtonText() == 'expand') ? 12 : 22}"><span>Impression & Requests</span></th>

                                        <!-- ko if: isDefaultFilters() && (viewModeSelected() === 'daily' || viewModeSelected() === 'brands') && colapsVideoRPMButtonText() != 'expand' -->
                                            <th class="expanded-cells" data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="9"><span>AdBlock Recovery</span></th>
                                        <!-- /ko -->

                                        <!-- ko if: isDefaultFilters() && (viewModeSelected() === 'daily' || viewModeSelected() === 'brands') -->
                                        <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="6"><span>Site Interactions</span></th>
                                        <!-- /ko -->

                                <!-- /ko -->

                                <!-- ko if: viewModeSelected() == 'advertisers' -->
                                <th data-bind="attr: { colspan: rpmColumnsNumber(), class: (trafficSource() == 2) ? 'colgroup-4 end start' : 'section-4'}"><span>RPM</span></th>

                                <th data-bind="attr: { colspan: cpmColumnsNumber(), class: (trafficSource() == 2) ? 'colgroup-4 end start' : 'section-4'}"><span>CPM</span></th>

                                <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="2"><span>SV</span></th>
                                <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end expanded-cells' : 'section-4 expanded-cells', colspan: trafficColumnsNumber()}"><span>Traffic</span></th>
                                <!-- /ko -->
                            </tr>
                            <!-- /ko -->

                            <!-- ko if: viewModeSelected() == 'daily' -->

                                <!-- portfolios-->
                                <tr class="list-header-section">
                                    <!-- ko if: hasPortfolioHeaders() -->
                                        <!-- ko foreach: portfolioHeaders -->
                                            <th class="section-portfolio" data-bind="attr: { colspan: ($index() === 0) ? cols +1: cols}"><span data-bind="text: name, css: $data.class"></span></th>
                                        <!-- /ko -->
                                        <!-- ko if: showRevenueBreakdown() -->
                                            <th class="section-1" data-bind="attr: { colspan: (colapsVideoRPMButtonText() == 'expand') ? 9 : 13}"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                        <!-- /ko -->
                                        <!-- ko ifnot: showRevenueBreakdown() -->
                                            <th class="section-1" data-bind="attr: { colspan: 1}"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                        <!-- /ko -->
                                    <!-- /ko -->

                                    <!-- ko ifnot: hasPortfolioHeaders() -->
                                        <th class="section-1" style="border-right: 1px solid #d3d3d3;" data-bind="attr: { colspan: revenueHeaders().length + 1 }"><span data-bind="text: viewModeSelected"></span></th>
                                        <th class="section-1"><span data-bind="text: revenueOptionSelectedText()"></span></th>
                                    <!-- /ko -->


                                    <!-- ko if: showRevenueBreakdown() -->
                                        <!-- <th class="section-2"><span>Programmatic Revenue</span></th>
                                        <th class="section-2"><span>Affiliate Revenue</span></th>
                                        <th class="section-2"><span>Direct Revenue</span></th>
                                        <th class="section-2"><span>Sponsored Revenue</span></th>-->
                                    <!-- /ko -->

                                    <th data-bind="attr: { colspan: rpmColumnsNumber(), class: (trafficSource() == 2) ? 'colgroup-4 end start' : 'section-4'}"><span>RPM</span></th>

                                    <th data-bind="attr: { colspan: cpmColumnsNumber(), class: (trafficSource() == 2) ? 'colgroup-4 end start' : 'section-4'}"><span>CPM</span></th>

                                    <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="2"><span>SV</span></th>


                                    <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end expanded-cells' : 'section-4 expanded-cells', colspan: trafficColumnsNumber()}"><span>Traffic</span></th>
                                    <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4', colspan: (colapsVideoRPMButtonText() == 'expand') ? 12 : 22}"><span>Impression & Requests</span></th>

                                    <!-- ko if: isDefaultFilters() && (viewModeSelected() === 'daily' || viewModeSelected() === 'brands') && colapsVideoRPMButtonText() != 'expand' -->
                                        <th class="expanded-cells" data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="9"><span>AdBlock Recovery</span></th>
                                    <!-- /ko -->

                                    <!-- ko if: isDefaultFilters() && (viewModeSelected() === 'daily' || viewModeSelected() === 'brands') -->
                                    <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}" colspan="6"><span>Site Interactions</span></th>
                                    <!-- /ko -->

                                </tr>
                            <!-- /ko -->

                            <tr class="list-divider list-header-section">

                                <!-- ko ifnot: viewModeSelected() === 'brands' -->
                                    <th class="stick-col"></th>
                                <!-- /ko -->

                                <!-- ko foreach: revenueHeaders -->
                                    <!-- ko ifnot: ($parent.viewModeSelected() === 'advertisers' && $parent.colapsButtonText() != 'simplify' && (typeof(type) !== 'undefined' && typeof(name) !== 'undefined' && (type == 'yield_partner' || name.indexOf('ValStream_') !== -1)))  -->
                                        <!-- ko ifnot: $parent.viewModeSelected() === 'brands' -->
                                            <th  data-bind="css: $data.class"><span data-bind="text: name, class: $parent.getClassNames($data)"></span></th>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                <!-- /ko -->


                                <!-- ko if: (viewModeSelected() == 'advertisers' && colapsButtonText() != 'simplify')  -->
                                    <th><span>Exchange Bidding</span></th>
                                    <th><span>ValStream</span></th>
                                <!-- /ko -->

                                <!-- ko if: viewModeSelected() == 'advertisers' -->
                                <th><span>VAL-IN</span></th>
                                <th><span>VAL-OUT</span></th>
                                <th><span>VAL-OUT2</span></th>
                                <th><span>VAL-COMP</span></th>
                                <!-- /ko -->

                                <th class="section-department" data-bind="attr: { colspan: (viewModeSelected() == 'brands' ) ? 2 : 1 }" style="border-left: 1px solid #d3d3d3;"><span class="total">total</span></th>

                                <!-- ko if: showRevenueBreakdown() && viewModeSelected() != 'advertisers' -->
                                <th class="section-3"><span class="total">Prog.</span></th>
                                <th class="section-3"><span class="total">Aff.</span></th>
                                <th class="section-3"><span class="total">Direct</span></th>
                                <th class="section-3 expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span class="total">Dir. Display</span></th>
                                <th class="section-3 expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span class="total">Dir. Video</span></th>
                                <th class="section-3"><span class="total">Spon.</span></th>
                                <th class="section-3"><span class="total">Soc. & Vid.</span></th>
                                <th class="section-3"><span class="total">Premium</span></th>
                                <th class="section-3"><span class="total">MKTPLC</span></th>
                                <th class="section-3 expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span class="total">MP AFF.</span></th>
                                <th class="section-3 expanded-cells section-3-end" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span class="total">MP Placed</span></th>
                                <th class="section-3"><span class="total">Lead Gen</span></th>
                                <!-- /ko -->

                                <th><span>Disp.</span></th>
                                <th class="expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span>Disp. RPM30</span></th>
                                <th><span>Vid.</span></th>
                                <th class="expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span>Vid. RPM30</span></th>


                                <!-- ko if: showVideoRPMSplit() -->
                                <th class="expanded-cells"><span>Out1</span></th>
                                <!-- /ko -->

                                <th><span>Aff.</span></th>
                                <th class=""><span>Direct</span></th>
                                <th class="expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span>Dir. Display</span></th>
                                <th class="expanded-cells" data-bind="visible: colapsVideoRPMButtonText() != 'expand'"><span>Dir. Video</span></th>
                                <th class=""><span>Spon.</span></th>

                                <!-- ko if: showDeviceRpm() -->
                                <th><span>Desktop</span></th>
                                <th><span>Mobile</span></th>
                                <!-- /ko -->
                                <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}"><span class="total">Total</span></th>


                                <th><span>Display</span></th>
                                <th class="colgroup-0 end"><span>Video</span></th>

                                <th><span>Prog.</span></th>
                                <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}"><span class="total">Total</span></th>
                                <th><span>SESSIONS</span></th>

                                <th>
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;">
                                        <span>PAGEVIEWS</span>
                                        <!-- ko if: trafficSource() == 2 && suspiciousTrafficExclusions().length > 0 -->
                                        <div class="w-tooltips-adv auto-height">
                                            ${this.suspiciousTrafficExclusionsTooltip.getHtmlBuild()}
                                        </div>
                                        <!-- /ko -->
                                    </div>
                                </th>
                                <!-- ko if: trafficSource() == 2 -->
                                <th><span>PAGEVIEWS (NO SUSP.)</span></th>
                                <th class="expanded-cells" data-bind="visible: showPageviewsWithSuspicious()"><span>PAGEVIEWS (W/ SUSP.)</span></th>
                                <!-- /ko -->
                                <th><span>US%</span></th>
                                <!-- ko if: viewModeSelected() !== 'advertisers' -->
                                <th><span>PG/S</span></th>
                                <!-- /ko -->
                                <th><span>iOS/Android</span></th>
                                <!-- <th><span>GP/Article</span></th> -->
                                <!-- ko if: viewModeSelected() !== 'advertisers' -->
                                <th class="border-right"><span>Instream Views</span></th>
                                <!--<th>Removed vCtr</th>-->

                                <th><span>Disp. Imp/Sess</span></th>
                                <th>
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span>Disp. Fillrate</span>
                                        <div class="w-tooltips-adv auto-height short pos-last">
                                        ${this.displayFillrateTooltip.getHtmlBuild()}
                                        </div>
                                    </div>
                                </th>
                                <th><span>Disp. Imp % Dir</span></th>
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Disp. Impressions</span></th><!-- /ko -->
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Disp. ImpP30</span></th><!-- /ko -->
                                <th><span>Disp. Req/Sess</span></th>
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Disp. Requests</span></th><!-- /ko -->
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Disp. ReqP30</span></th><!-- /ko -->
                                <th><span>Disp. Bid Req/Sess</span></th>
                                <th><span>Vid. Imp/Sess</span></th>
                                <th>
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span>Vid. Fillrate</span>
                                        <div class="w-tooltips-adv auto-height short pos-last">
                                        ${this.videoFillrateTooltip.getHtmlBuild()}
                                        </div>
                                    </div>
                                </th>
                                <th><span>Vid. Imp % Dir</span></th>
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Vid. Impressions</span></th><!-- /ko -->
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Vid. ImpP30</span></th><!-- /ko -->
                                <th><span>Vid. Req/Sess</span></th>
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Vid. Requests</span></th><!-- /ko -->
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Vid. ReqP30</span></th><!-- /ko -->
                                <th><span>Vid. Bid Req/Sess</span></th>
                                <th><span>Viewability</span></th>
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Total Impressions</span></th><!-- /ko -->
                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' --><th class="expanded-cells"><span>Total Requests</span></th><!-- /ko -->

                                <th data-bind="attr: { class: (trafficSource() == 2) ? 'colgroup-4 end' : 'section-4'}"><span class="total">Total I/S</span></th>

                                <!-- /ko -->

                                <!-- ko if: isDefaultFilters() && (viewModeSelected() === 'daily' || viewModeSelected() === 'brands') && colapsVideoRPMButtonText() != 'expand'  -->
                                <th class="expanded-cells"><span>Revenue</span></th>
                                <th class="expanded-cells"><span>Pageviews</span></th>
                                <th class="expanded-cells"><span>Sessions</span></th>
                                <th class="expanded-cells"><span>rpm</span></th>
                                <th class="expanded-cells"><span>rpm display</span></th>
                                <th class="expanded-cells"><span>rpm video</span></th>
                                <th class="expanded-cells"><span>rpm desktop</span></th>
                                <th class="expanded-cells"><span>rpm mobile</span></th>
                                <th class="expanded-cells border-right"><span>sv</span></th>
                                <!-- /ko -->

                                <!-- ko if: isDefaultFilters() && (viewModeSelected() === 'daily' || viewModeSelected() === 'brands') -->
                                <th><span>Prem. Users</span></th>
                                <th><span>Prem. Unsubs</span></th>
                                <th><span>Email Subs</span></th>
                                <th><span>Reg. Users</span></th>
                                <th><span>Logged-in PV</span></th>
                                <th>
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span>Sign-up Ratio</span>
                                        <div class="w-tooltips-adv auto-height short pos-last">
                                        ${this.signUpRatioTooltip.getHtmlBuild()}
                                        </div>
                                    </div>
                                </th>
                                <!-- /ko -->



                            </tr>
                        <!-- /ko -->


                        <!-- ko if: viewModeSelected() == 'zones' -->

                            <tr class="list-header-section">

                                <!-- ko foreach: revenueHeaders -->
                                    <th class="section-portfolio" data-bind="attr: { colspan: ($index() === 0) ? ($parent.metricColumnsNumberPerZone() + 1) :  $parent.metricColumnsNumberPerZone()}"><span data-bind="text: name, css: $data.class"></span></th>
                                <!-- /ko -->
                                <th class="section-1" data-bind="attr: { colspan: (metricColumnsNumberPerZone()) }"><span>Totals</span></th>
                                <th class="section-3" colspan = "2"><span>Traffic</span></th>
                            </tr>

                            <tr class="list-divider list-header-section">
                                <th class="stick-col"></th>
                                <!-- ko foreach: revenueHeaders -->

                                    <th><span>Revenue</span></th>
                                    <th><span>RPM</span></th>
                                    <th><span>Req/Sess</span></th>
                                    <th><span>Imp/Sess</span></th>

                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' -->

                                        <th class="expanded-cells"><span>SV</span></th>
                                        <th class="expanded-cells"><span>CPM</span></th>
                                        <th class="expanded-cells"><span>Fill Rate</span></th>
                                        <th class="expanded-cells"><span>Requests</span></th>
                                        <th class="expanded-cells"><span>Impressions</span></th>

                                    <!-- /ko -->

                                <!-- /ko -->
                                <th><span>Revenue</span></th>
                                <th><span>RPM</span></th>
                                <th><span>Req/Sess</span></th>
                                <th><span>Imp/Sess</span></th>


                                <!-- ko if: colapsVideoRPMButtonText() == 'simplify' -->

                                        <th class="expanded-cells"><span>SV</span></th>
                                        <th class="expanded-cells"><span>CPM</span></th>
                                        <th class="expanded-cells"><span>Fill Rate</span></th>
                                        <th class="expanded-cells"><span>Requests</span></th>
                                        <th class="expanded-cells"><span>Impressions</span></th>

                                <!-- /ko -->

                                <th><span>Sessions</span></th>
                                <th><span>Pageviews</span></th>


                            </tr>

                        <!-- /ko -->

                    </thead>

                    <tbody>

                    <!-- ko if: viewModeSelected() == 'brands' && gpBrandData().length > 0 -->
                        <!-- ko foreach: gpBrandData() -->
                        <tr class="" data-bind="css: { 'sub-total': $data.sideHeaders.brand.name == 'Group Total', 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1 }, event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, style: { borderBottom: $data.sideHeaders.brand.name == 'Portfolio Total' ? '1px solid #93b3f9' : '', 'background-color': $data.sideHeaders.brand.name == 'Portfolio Total' ? '#eaf0fe' : '' }">
                                <!-- ko if: $data.sideHeaders.brand.name != 'Total' -->

                                    <td class="stick-col stick-col-portfolio" data-bind="css: ($data.sideHeaders.brand.name == 'Portfolio Total') ? 'portfolio-total' : ($data.sideHeaders.brand.name == 'Group Total') ? 'department-total' : ''">
                                        <span class="" data-bind="text: $data.sideHeaders.portfolio.name, css: $data.sideHeaders.portfolio.class"></span>
                                    </td>
                                    <td class="stick-col stick-col-brand" data-bind="css: ($data.sideHeaders.brand.name == 'Portfolio Total') ? 'brand-total' : ($data.sideHeaders.brand.name == 'Group Total') ? 'brand-total section-3' : ''">
                                        <span data-bind="text: $data.sideHeaders.brand.shortName, css: $data.sideHeaders.brand.class"></span>
                                    </td>

                                <!-- /ko -->

                                <!-- ko if: $data.sideHeaders.brand.name == 'Total' -->
                                    <td class="stick-col stick-col-brand" >
                                        <span style="font-size: 1.3rem;padding-left: 0;" data-bind="text: $data.sideHeaders.brand.shortName, css: $data.sideHeaders.brand.class"></span>
                                    </td>
                                <!-- /ko -->

                                <!-- Brand specific table data -->
                                <!-- ko if: $data.data -->
                                    <td class="section-2 section-department">
                                        <!-- ko if: ($parent.revenueOptionSelected() === 'total_rev')  -->
                                            <span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.totalRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                        <!-- /ko -->

                                        <!-- ko if: ($parent.revenueOptionSelected() === 'rpm_count')  -->
                                            <span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.totalRevenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                        <!-- /ko -->

                                        <!-- ko if: ($parent.revenueOptionSelected() === 'rev_percentage')  -->
                                            <span class="total" data-bind="text: Number($data.data.totalRevenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        <!-- /ko -->

                                        <!-- ko if: ($parent.revenueOptionSelected() === 'inventory')  -->
                                            <span class="total" data-bind="text: $data.data.totalImpressions.toLocaleString('en-EG')"></span>
                                        <!-- /ko -->

                                        <!-- ko if: ($parent.revenueOptionSelected() === 'inv_percentage')  -->
                                            <span class="total" data-bind="text: Number($data.data.totalImpressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        <!-- /ko -->
                                    </td>
                                    <!-- ko if: $parent.showRevenueBreakdown() -->
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.programmaticRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.affiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.directRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3 expanded-cells" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.directDisplayRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3 expanded-cells" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.directVideoRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.sponsoredRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.socialRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.premiumRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.marketplaceRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3 expanded-cells" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.marketplaceAffiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3 expanded-cells section-3-end" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.marketplacePlacedRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.leadgenRevenueTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                    <!-- /ko -->
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.bannerRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.bannerRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td><!-- /ko -->
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.videoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.videoRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td><!-- /ko -->

                                    <!-- ko if: $parent.showVideoRPMSplit() -->
                                        <td class="expanded-cells"><span>N/A</span></td>
                                    <!-- /ko -->

                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.affiliateRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.directRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="expanded-cells" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.directDisplayRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="expanded-cells" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.directVideoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.sponsoredRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                    <!-- ko if: $parent.showDeviceRpm() -->
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.desktopRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.mobileRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <!-- /ko -->

                                    <td class="section-4"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.displayCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="colgroup-0 end"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.videoCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-4"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number($data.data.totalSv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                    <td><span data-bind="text: Number($data.data.sessions).toLocaleString('en-EG')"></span></td>
                                    <td><span class="pageviews-primary-value" data-bind="text: Number($data.data.pageviews).toLocaleString('en-EG')"></span></td>
                                    <!-- ko if: $parent.trafficSource() == 2 -->
                                    <td data-bind="css: { 'active-pageviews-without-suspicious': $data.data.usesPageviewsWithoutSuspicious }, attr: { title: $data.data.usesPageviewsWithoutSuspicious ? 'Active pageviews: suspicious traffic excluded.' : '' }"><span class="pageviews-comparison-value" data-bind="text: Number($data.data.pageviewsWithoutSuspicious || 0).toLocaleString('en-EG')"></span></td>
                                    <td class="expanded-cells" data-bind="visible: $parent.showPageviewsWithSuspicious()"><span class="pageviews-comparison-value" data-bind="text: Number($data.data.pageviewsWithSuspicious || 0).toLocaleString('en-EG')"></span></td>
                                    <!-- /ko -->
                                    <td><span data-bind="text: Number($data.data.sessionsUSPercent).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) +'%'"></span></td>
                                    <td><span data-bind="text: Number($data.data.pgs).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: $data.data.ios_android_sessions"></span></td>
                                    <td><span data-bind="text: Number($data.data.instreamViews).toLocaleString('en-EG')"></span></td>


                                    <td><span data-bind="text: Number($data.data.banner_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number($data.data.banner_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <td><span data-bind="text: Number($data.data.banner_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.bannerImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.bannerImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                    <td><span data-bind="text: Number($data.data.banner_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.banner_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.banner_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                    <td><span data-bind="text: Number($data.data.banner_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number($data.data.video_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number($data.data.video_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <td><span data-bind="text: Number($data.data.video_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.videoImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.videoImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                    <td><span data-bind="text: Number($data.data.video_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.video_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.video_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                    <td><span data-bind="text: Number($data.data.video_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: $parent.formatViewabilityPercent($data.data.viewability)"></span></td>
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.bannerImpressions + $data.data.videoImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                    <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td><span data-bind="text: Number($data.data.banner_requests + $data.data.video_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                    <td class="section-4"><span data-bind="text: Number($data.data.imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>


                                    <!-- ko if: $parent.isDefaultFilters() && ($parent.viewModeSelected() === 'daily' || $parent.viewModeSelected() === 'brands') && $parent.colapsVideoRPMButtonText() != 'expand' -->
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryPageviews).toLocaleString('en-EG')"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoverySessions).toLocaleString('en-EG')"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryRpmDisplay).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryRpmVideo).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryRpmDesktop).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoveryRpmMobile).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="expanded-cells border-right"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number($data.data.adblockRecoverySv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->


                                    <!-- ko if: $parent.isDefaultFilters() && ($parent.viewModeSelected() === 'daily' || $parent.viewModeSelected() === 'brands') -->
                                    <td><span data-bind="text: Number($data.data.newPremiumUsers).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number($data.data.premiumUserUnsubs).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number($data.data.newsletterUniqueSubscribers).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number($data.data.newMembers).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number($data.data.loggedInPageviews_per_pageviews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <td><span data-bind="text: Number($data.data.signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <!-- /ko -->

                                <!-- /ko -->

                                <!-- Subtotal table data (both portfolio subtotals and department subtotals) -->
                                <!-- ko ifnot: $data.data -->
                                    <!-- ko foreach: $parent.portfolioSubtotal() -->
                                        <!-- ko if: ($data.type == 'department' && $parent.sideHeaders.portfolio.id == '' && $parent.sideHeaders.department.id == $data.idDepartment)  || ($data.type == 'portfolio' && $parent.sideHeaders.portfolio.id == $data.idPortfolio) -->
                                            <td class="section-2 section-department">
                                                <!-- ko if: ($parents[1].revenueOptionSelected() === 'total_rev')  -->
                                                    <span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(totalRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                                <!-- /ko -->

                                                <!-- ko if: ($parents[1].revenueOptionSelected() === 'rpm_count')  -->
                                                    <span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(totalRevenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                                <!-- /ko -->

                                                <!-- ko if: ($parents[1].revenueOptionSelected() === 'rev_percentage')  -->
                                                    <span class="total" data-bind="text: Number(totalRevenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                <!-- /ko -->

                                                <!-- ko if: ($parents[1].revenueOptionSelected() === 'inventory')  -->
                                                    <span class="total" data-bind="text: totalImpressions.toLocaleString('en-EG')"></span>
                                                <!-- /ko -->

                                                <!-- ko if: ($parents[1].revenueOptionSelected() === 'inv_percentage')  -->
                                                    <span class="total" data-bind="text: Number(totalImpressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                <!-- /ko -->
                                            </td>
                                            <!-- ko if: $parents[1].showRevenueBreakdown() -->
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(programmaticRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(affiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(directRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3 expanded-cells" data-bind="visible: $parents[1].colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(directDisplayRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3 expanded-cells" data-bind="visible: $parents[1].colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(directVideoRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(sponsoredRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(socialRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(premiumRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(marketplaceRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3 expanded-cells" data-bind="visible: $parents[1].colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(marketplaceAffiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3 expanded-cells section-3-end" data-bind="visible: $parents[1].colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(marketplacePlacedRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td class="section-3" ><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(leadgenRevenueTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <!-- /ko -->
                                            <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(bannerRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(bannerRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td><!-- /ko -->
                                            <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(videoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(videoRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td><!-- /ko -->

                                            <!-- ko if: $parents[1].showVideoRPMSplit() -->
                                                <td class="expanded-cells"><span class="total">N/A</span></td>
                                            <!-- /ko -->

                                            <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(affiliateRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                            <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(directRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <td class="expanded-cells" data-bind="visible: $parents[1].colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(directDisplayRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <td class="expanded-cells" data-bind="visible: $parents[1].colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(directVideoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(sponsoredRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                            <!-- ko if: $parents[1].showDeviceRpm() -->
                                                <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(desktopRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                                <td><span class="total sub-total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(mobileRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <!-- /ko -->

                                            <td class="border-right"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>


                                            <td><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(displayCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <td class="end"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(videoCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>


                                            <td><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                            <td class="border-right"><span class="total" data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(totalSv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                            <td><span class="total" data-bind="text: Number(sessions).toLocaleString('en-EG')"></span></td>
                                            <td><span class="total pageviews-primary-value" data-bind="text: Number(pageviews).toLocaleString('en-EG')"></span></td>
                                            <!-- ko if: $parents[1].trafficSource() == 2 -->
                                            <td><span class="pageviews-comparison-value" data-bind="text: Number(pageviewsWithoutSuspicious || 0).toLocaleString('en-EG')"></span></td>
                                            <td class="expanded-cells" data-bind="visible: $parents[1].showPageviewsWithSuspicious()"><span class="pageviews-comparison-value" data-bind="text: Number(pageviewsWithSuspicious || 0).toLocaleString('en-EG')"></span></td>
                                            <!-- /ko -->
                                            <td><span class="total" data-bind="text: Number(sessionsUSPercent).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <td><span class="total" data-bind="text: Number(pgs).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td><span class="total" data-bind="text: ios_android_sessions"></span></td>
                                            <td><span class="total" data-bind="text: Number(instreamViews).toLocaleString('en-EG')"></span></td>


                                            <td><span class="total" data-bind="text: Number(banner_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td><span class="total" data-bind="text: Number(banner_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <td><span class="total" data-bind="text: Number(banner_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(bannerImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(bannerImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                            <td><span class="total" data-bind="text: Number(banner_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(banner_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(banner_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                            <td><span class="total" data-bind="text: Number(banner_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td><span class="total" data-bind="text: Number(video_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td><span class="total" data-bind="text: Number(video_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <td><span class="total" data-bind="text: Number(video_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(videoImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(videoImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                            <td><span class="total" data-bind="text: Number(video_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(video_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(video_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                            <td><span class="total" data-bind="text: Number(video_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td><span data-bind="text: $parents[1].formatViewabilityPercent(viewability)"></span></td>
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(bannerImpressions + videoImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                            <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' --><td><span class="total" data-bind="text: Number(banner_requests + video_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                            <td class="border-right"><span class="total" data-bind="text: Number(imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                                            <!-- ko if: $parents[1].isDefaultFilters() && ($parents[1].viewModeSelected() === 'daily' || $parents[1].viewModeSelected() === 'brands') && $parents[1].colapsVideoRPMButtonText() != 'expand' -->
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryPageviews).toLocaleString('en-EG')"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoverySessions).toLocaleString('en-EG')"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmDisplay).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmVideo).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmDesktop).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td class="expanded-cells"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmMobile).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                            <td class="expanded-cells border-right"><span data-bind="text: ($parents[1].trafficSource() == 1) ? 'N/A' : Number(adblockRecoverySv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                                            <!-- /ko -->

                                            <!-- ko if: $parents[1].isDefaultFilters()  && ($parents[1].viewModeSelected() === 'daily' || $parents[1].viewModeSelected() === 'brands')-->
                                            <td><span class="total" data-bind="text: Number(newPremiumUsers).toLocaleString('en-EG')"></span></td>
                                            <td><span class="total" data-bind="text: Number(premiumUserUnsubs).toLocaleString('en-EG')"></span></td>
                                            <td><span class="total" data-bind="text: Number(newsletterUniqueSubscribers).toLocaleString('en-EG')"></span></td>
                                            <td><span class="total" data-bind="text: Number(newMembers).toLocaleString('en-EG')"></span></td>
                                            <td><span class="total" data-bind="text: Number(loggedInPageviews_per_pageviews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <td><span class="total" data-bind="text: Number(signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    <!-- /ko -->
                                <!-- /ko -->
                            </tr>
                        <!-- /ko -->
                    <!-- /ko -->


                    <!-- ko if: viewModeSelected() == 'zones'-->

                        <!-- ko if: zonesModeGrouping() == 'daily'-->

                            <!-- ko foreach: gpZoneData -->

                                <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'border-top': groupingColumn == 'Thursday, 2024-05-30' ? 'solid #739efb 2px' : '' }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1 }">

                                <td class="stick-col"><span data-bind="text: groupingColumn"></span></td>


                                <!-- ko foreach: revenueData -->

                                    <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                    <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                    <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(reqPerSess).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                    <td class="border-right" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(impPerSess).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                    <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' -->

                                        <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(fillRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: Number(requests).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: Number(impressions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                    <!-- /ko -->


                                <!-- /ko -->

                                <td data-bind="css: $data.class"><span data-bind="text: Number(sessions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                <td data-bind="css: $data.class"><span data-bind="text: Number(pageviews).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                </tr>

                            <!-- /ko -->
                        <!-- /ko -->

                        <!-- ko if: zonesModeGrouping() == 'brands'-->

                            <!-- ko foreach: gpZoneDataForBrands -->
                                <tr class="" data-bind="css: { 'sub-total': $data.sideHeaders.brand.name == 'Group Total', 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1 }, event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, style: { borderBottom: $data.sideHeaders.brand.name == 'Portfolio Total' ? '1px solid #93b3f9' : '', 'background-color': $data.sideHeaders.brand.name == 'Portfolio Total' ? '#eaf0fe' : '' }">
                                    <!-- ko if: $data.sideHeaders.brand.name != 'Total' -->

                                        <td class="stick-col stick-col-portfolio" data-bind="css: ($data.sideHeaders.brand.name == 'Portfolio Total') ? 'portfolio-total' : ($data.sideHeaders.brand.name == 'Group Total') ? 'department-total' : ''">
                                            <span class="" data-bind="text: $data.sideHeaders.portfolio.name, css: $data.sideHeaders.portfolio.class"></span>
                                        </td>
                                        <td class="stick-col stick-col-brand" data-bind="css: ($data.sideHeaders.brand.name == 'Portfolio Total') ? 'brand-total' : ($data.sideHeaders.brand.name == 'Group Total') ? 'brand-total section-3' : ''">
                                            <span data-bind="text: $data.sideHeaders.brand.shortName, css: $data.sideHeaders.brand.class"></span>
                                        </td>

                                    <!-- /ko -->

                                    <!-- ko if: $data.sideHeaders.brand.name == 'Total' -->
                                        <td class="stick-col stick-col-brand" >
                                            <span style="font-size: 1.3rem;padding-left: 0;" data-bind="text: $data.sideHeaders.brand.shortName, css: $data.sideHeaders.brand.class"></span>
                                        </td>
                                    <!-- /ko -->

                                    <!-- Brand specific table data -->
                                        <!-- ko if: $data.data -->
                                            <!-- ko foreach: $data.data.revenueData -->

                                                <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(reqPerSess).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                <td class="border-right" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(impPerSess).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                                <!-- ko if: $parents[1].colapsVideoRPMButtonText() == 'simplify' -->

                                                    <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                    <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                    <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(fillRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                    <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: Number(requests).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                    <td class="expanded-cells" data-bind="css: $data.class"><span data-bind="text: Number(impressions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                                <!-- /ko -->
                                            <!-- /ko -->

                                            <td data-bind="css: $data.class"><span data-bind="text: Number($data.data.sessions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                            <td data-bind="css: $data.class"><span data-bind="text: Number($data.data.pageviews).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <!-- /ko -->

                                    <!-- Subtotal table data (both portfolio subtotals and department subtotals) -->
                                        <!-- ko ifnot: $data.data -->
                                            <!-- ko foreach: $parent.portfolioSubtotalForZones() -->
                                                <!-- ko if: ($data.type == 'department' && $parent.sideHeaders.portfolio.id == '' && $parent.sideHeaders.department.id == $data.idDepartment)  || ($data.type == 'portfolio' && $parent.sideHeaders.portfolio.id == $data.idPortfolio) -->

                                                    <!-- ko foreach: revenueData -->

                                                        <td class="total"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                        <td class="total"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                        <td class="total"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(reqPerSess).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                        <td class="total"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(impPerSess).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                                        <!-- ko if: $parents[2].colapsVideoRPMButtonText() == 'simplify' -->

                                                            <td class="total expanded-cells"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                            <td class="total expanded-cells"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                            <td class="total expanded-cells"><span data-bind="text: $parents[2].swapNegativeSignForParentheses(Number(fillRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                            <td class="total expanded-cells"><span data-bind="text: Number(requests).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                            <td class="total expanded-cells"><span data-bind="text: Number(impressions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>

                                                        <!-- /ko -->
                                                    <!-- /ko -->

                                                    <td class="total"><span data-bind="text: Number(sessions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                    <td class="total"><span data-bind="text: Number(pageviews).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                                <!-- /ko -->
                                            <!-- /ko -->
                                        <!-- /ko -->
                                </tr>

                            <!-- /ko -->

                        <!-- /ko -->

                    <!-- /ko -->

                    <!-- ko if: (viewModeSelected() !== 'brands' && viewModeSelected() !== 'zones' && gpData().length > 0) -->
                        <!-- ko foreach: gpData -->
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'border-top': date == 'Thursday, 2024-05-30' ? 'solid #739efb 2px' : '' }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1 }">

                                <td class="stick-col"><span data-bind="text: date"></span></td>

                                <!-- ko foreach: revenueData -->
                                    <!-- ko ifnot: ($parents[1].viewModeSelected() === 'advertisers' && $parents[1].colapsButtonText() !== 'simplify' && (typeof(headerType) !== 'undefined' && typeof(headerName) !== 'undefined' && (headerType === 'yield_partner' || headerName.indexOf('ValStream_') !== -1)))  -->

                                        <!-- ko if: ($parents[1].revenueOptionSelected() === 'total_rev')  -->
                                        <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <!-- /ko -->

                                        <!-- ko if: ($parents[1].revenueOptionSelected() === 'rpm_count')  -->
                                        <td data-bind="css: $data.class"><span data-bind="text: $parents[1].swapNegativeSignForParentheses(Number(revenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <!-- /ko -->

                                        <!-- ko if: ($parents[1].revenueOptionSelected() === 'rev_percentage')  -->
                                        <td data-bind="css: $data.class"><span data-bind="text: Number(revenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <!-- /ko -->

                                        <!-- ko if: ($parents[1].revenueOptionSelected() === 'inventory')  -->
                                            <td data-bind="css: $data.class">
                                                <!-- ko if: $parents[1].viewModeSelected() === 'daily' || ($parents[1].viewModeSelected() === 'advertisers' && $data.headerName !== undefined && $data.headerName.startsWith('ValStream_') && $parents[1].colapsButtonText() === 'simplify')  -->
                                                    <!-- ko if: $parent.date !== 'TOTAL'  -->
                                                        <span data-bind="text: ($data.headerType === 'brand' || $data.headerType === 'advertiser' || $data.headerType === 'yield_partner') ? Number(impressions).toLocaleString('en-EG') + ' (' + Number(videoImpressionsOutstream2ErrorRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)' : Number(impressions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span>
                                                    <!-- /ko -->
                                                <!-- /ko -->

                                                <!-- ko if: $parent.date === 'TOTAL' || ($parents[1].viewModeSelected() !== 'daily' && !($parents[1].viewModeSelected() === 'advertisers' && $data.headerName !== undefined && $data.headerName.startsWith('ValStream_') && $parents[1].colapsButtonText() === 'simplify')) -->
                                                    <span data-bind="text: Number(impressions).toLocaleString('en-EG'), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span>
                                                <!-- /ko -->
                                            </td>
                                        <!-- /ko -->

                                        <!-- ko if: ($parents[1].revenueOptionSelected() === 'inv_percentage')  -->
                                        <td><span data-bind="text: Number(impressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}), style: { 'background-color': ($data.progressBackgroundColor !== undefined && $data.progressBackgroundColor !== null) ? $data.progressBackgroundColor : '' }, attr: {title: ($data.progressTooltip !== undefined && $data.progressTooltip !== null) ? $data.progressTooltip : ''}"></span></td>
                                        <!-- /ko -->

                                    <!-- /ko -->
                                <!-- /ko -->

                                <!-- ko if: ($parent.viewModeSelected() === 'advertisers' && $parent.viewModeSelected() !== 'brands'  && $parent.colapsButtonText() !== 'simplify')  -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'total_rev')  -->
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalRevenueYield).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalRevenueValStream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'rpm_count')  -->
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalYieldRevenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalValStreamRevenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'rev_percentage')  -->
                                    <td><span data-bind="text: Number(totalYieldRevenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number(totalValStreamRevenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'inventory')  -->
                                    <td><span data-bind="text: totalYieldImpressions.toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: totalValStreamImpressions.toLocaleString('en-EG')"></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'inv_percentage')  -->
                                    <td><span data-bind="text: Number(totalYieldImpressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number(totalValStreamImpressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->

                                <!-- /ko -->

                                <!-- ko if: ($parent.viewModeSelected() == 'advertisers') -->

                                    <!-- You might be wondering where there's duplcation here. There is a bug where only revenue is displayed even when a different revenue option is selected (like inventory or percentage). This will be fixed in another task but in the meantime, I had to partially fix the inventory revenue option for Val-out2 to complete my task. Don't forget to also fix the advertisers export when you fix this! -->
                                    <!-- ko if: ($parent.revenueOptionSelected() === 'total_rev')  -->
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'rpm_count')  -->
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'rev_percentage')  -->
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'inventory')  -->
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: (date !== 'TOTAL') ? $parent.swapNegativeSignForParentheses(Number(videoImpressionsOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})) + ' (' + Number(videoImpressionsOutstream2ErrorRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)' : $parent.swapNegativeSignForParentheses(Number(videoImpressionsOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}))"></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                    <!-- /ko -->

                                    <!-- ko if: ($parent.revenueOptionSelected() === 'inv_percentage')  -->
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                        <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))" ></span></td>
                                    <!-- /ko -->
                                <!-- /ko -->

                                <td class="section-2 section-department" style="border-left: 1px solid #d3d3d3;">
                                <!-- ko if: ($parent.revenueOptionSelected() === 'total_rev')  -->
                                    <span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                <!-- /ko -->

                                <!-- ko if: ($parent.revenueOptionSelected() === 'rpm_count')  -->
                                    <span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalRevenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                <!-- /ko -->

                                <!-- ko if: ($parent.revenueOptionSelected() === 'rev_percentage')  -->
                                    <span class="total" data-bind="text: Number(totalRevenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                <!-- /ko -->

                                <!-- ko if: ($parent.revenueOptionSelected() === 'inventory')  -->
                                    <span class="total" data-bind="text: totalImpressions.toLocaleString('en-EG')"></span>
                                <!-- /ko -->

                                <!-- ko if: ($parent.revenueOptionSelected() === 'inv_percentage')  -->
                                    <span class="total" data-bind="text: Number(totalImpressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                <!-- /ko -->
                                </td>

                                <!-- ko if: $parent.showRevenueBreakdown() && $parent.viewModeSelected() != 'advertisers' -->
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(programmaticRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(affiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(directRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3 expanded-cells" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(directDisplayRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3 expanded-cells" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(directVideoRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(sponsoredRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(socialRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(premiumRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(marketplaceRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3 expanded-cells" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(marketplaceAffiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3 expanded-cells section-3-end" class="test" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(marketplacePlacedRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                    <td class="section-3" class="test"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(leadgenRevenueTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- /ko -->

                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(bannerRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' -->
                                <td class="expanded-cells"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(bannerRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- /ko -->
                                <td>
                                    <span style="float:left;" data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                    <!-- ko template: {name: 'outStreamRatiosForDate',  data: {outstreamRatioData: $parent.outstreamRatioData(), outstreamDatesWithNewRatios: $parent.outstreamDatesWithNewRatios(), currentDate : date}} --><!-- /ko -->
                                </td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' -->
                                <td class="expanded-cells"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- /ko -->

                                <!-- ko if: $parent.showVideoRPMSplit() -->
                                    <td class="expanded-cells"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoOutstreamRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- /ko -->

                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(affiliateRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>


                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(directRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <td class="expanded-cells" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(directDisplayRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <td class="expanded-cells" data-bind="visible: $parent.colapsVideoRPMButtonText() != 'expand'"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(directVideoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(sponsoredRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                <!-- ko if: $parent.showDeviceRpm() -->
                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(desktopRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(mobileRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- /ko -->
                                <td class="section-4"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(displayCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <td class="end"><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(videoCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>

                                <td><span data-bind="text: $parent.swapNegativeSignForParentheses(Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <td class="section-4"><span class="total" data-bind="text: $parent.swapNegativeSignForParentheses(Number(totalSv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span></td>
                                <!-- <td><span data-bind="text: Number(gp_to_articles).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td> -->
                                <td><span data-bind="text: Number(sessions).toLocaleString('en-EG')"></span></td>
                                <td><span class="pageviews-primary-value" data-bind="text: Number(pageviews).toLocaleString('en-EG')"></span></td>
                                <!-- ko if: $parent.trafficSource() == 2 -->
                                <td data-bind="css: { 'active-pageviews-without-suspicious': usesPageviewsWithoutSuspicious }, attr: { title: usesPageviewsWithoutSuspicious ? 'Active pageviews: suspicious traffic excluded.' : '' }"><span class="pageviews-comparison-value" data-bind="text: Number(pageviewsWithoutSuspicious || 0).toLocaleString('en-EG')"></span></td>
                                <td class="expanded-cells" data-bind="visible: $parent.showPageviewsWithSuspicious()"><span class="pageviews-comparison-value" data-bind="text: Number(pageviewsWithSuspicious || 0).toLocaleString('en-EG')"></span></td>
                                <!-- /ko -->
                                <td><span data-bind="text: Number(sessionsUSPercent).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <!-- ko if: ($parent.viewModeSelected() !== 'advertisers') -->
                                <td><span data-bind="text: Number(pgs).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- /ko -->
                                <td><span data-bind="text: ios_android_sessions"></span></td>
                                <!-- ko if: ($parent.viewModeSelected() !== 'advertisers') -->
                                <td class="border-right"><span data-bind="text: Number(instreamViews).toLocaleString('en-EG')"></span></td>

                                <td><span data-bind="text: Number(banner_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td><span data-bind="text: Number(banner_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td><span data-bind="text: Number(banner_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(bannerImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(bannerImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                <td><span data-bind="text: Number(banner_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(banner_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(banner_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                <td><span data-bind="text: Number(banner_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td><span data-bind="text: Number(video_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td><span data-bind="text: Number(video_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td><span data-bind="text: Number(video_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(videoImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(videoImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                <td><span data-bind="text: Number(video_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(video_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(video_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td><!-- /ko -->
                                <td><span data-bind="text: Number(video_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td><span data-bind="text: $parent.formatViewabilityPercent(viewability)"></span></td>
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(bannerImpressions + videoImpressions).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                <!-- ko if: $parent.colapsVideoRPMButtonText() == 'simplify' --><td class="expanded-cells"><span data-bind="text: Number(banner_requests + video_requests).toLocaleString('en-EG')"></span></td><!-- /ko -->
                                <td class="section-4"><span class="total" data-bind="text: Number(imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                                <!-- /ko -->

                                <!-- ko if: $parent.isDefaultFilters() && ($parent.viewModeSelected() === 'daily' || $parent.viewModeSelected() === 'brands') && $parent.colapsVideoRPMButtonText() != 'expand' -->
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryPageviews).toLocaleString('en-EG')"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoverySessions).toLocaleString('en-EG')"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmDisplay).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmVideo).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmDesktop).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="expanded-cells"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoveryRpmMobile).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="expanded-cells border-right"><span data-bind="text: ($parent.trafficSource() == 1) ? 'N/A' : Number(adblockRecoverySv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- /ko -->


                                <!-- ko if: $parent.isDefaultFilters() && ($parent.viewModeSelected() === 'daily' || $parent.viewModeSelected() === 'brands') -->
                                <td><span data-bind="text: Number(newPremiumUsers).toLocaleString('en-EG')"></span></td>
                                <td><span data-bind="text: Number(premiumUserUnsubs).toLocaleString('en-EG')"></span></td>
                                <td><span data-bind="text: Number(newsletterUniqueSubscribers).toLocaleString('en-EG')"></span></td>
                                <td><span data-bind="text: Number(newMembers).toLocaleString('en-EG')"></span></td>
                                <td><span data-bind="text: Number(loggedInPageviews_per_pageviews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td class="border-right"><span data-bind="text: Number(signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <!-- /ko -->


                            </tr>
                        <!-- /ko -->
                        <!-- /ko -->
                    </tbody>
                </table>
            </div>
            </div>

            <script type="text/html" id="outStreamRatiosForDate">
            <!-- ko if:  $data.currentDate != "TOTAL" -->

            <div class="dropdown" style="display:flex;">
                <span class="table-dropdown-toggle icon i-dropdown-simple"></span>
                <!-- ko if: $data.outstreamDatesWithNewRatios[$data.currentDate] == true -->
                <span style="padding-left:.25rem;">*</span>
                <!-- /ko -->
                    <div class="table-dropdown-list">
                        <div class="w-form double-column">

                            <!-- ko foreach: { data: $data.outstreamRatioData, as: 'outstreamRatio' } -->
                                <!-- ko if: $parent.currentDate == outstreamRatio.date -->
                                <div class="form-group">
                                    <div><span data-bind="text: outstreamRatio.brandName"></span><span data-bind="text: (outstreamRatio.isRatioDate === true) ? '*' : ''"></span></div>
                                    <div><span data-bind="text: (outstreamRatio.ratioA * 100) + '/' + (outstreamRatio.ratioB * 100)"></span></div>
                                </div>
                                <!-- /ko -->
                            <!-- /ko -->

                        </div>
                    </div>
                </div>
            <!-- /ko -->
            </script>

            <div id="gp-sheet-traffic-settings-dialog" class="w-lightbox dark-theme"
                 data-bind="css: {'is-visible': suspiciousTrafficSettingsOpen}">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form w-form-large traffic-settings-form">
                        <div class="form-header">
                            <h3 class="form-title">Sentinel Traffic Settings</h3>
                            <button type="button"
                                    class="close-btn icon i-close"
                                    aria-label="Close traffic settings"
                                    data-bind="click: closeSuspiciousTrafficSettings"></button>
                        </div>

                        <div class="form-body full-width traffic-settings-body">
                            <div class="traffic-settings-intro">
                                <p>Exclude suspicious traffic for a specific Sentinel brand and date.</p>
                                <p>
                                    Dates without an override include suspicious traffic. Overrides begin on
                                    <strong data-bind="text: suspiciousTrafficVariantsStartDate"></strong>.
                                </p>
                            </div>

                            <div class="traffic-settings-fields">
                                <div class="form-group">
                                    <label class="form-label" for="suspicious-traffic-brand">Brand</label>
                                    <select id="suspicious-traffic-brand"
                                            class="input-text"
                                            data-bind="options: availableBrandsOptions,
                                                       optionsText: 'name',
                                                       optionsValue: 'id',
                                                       value: suspiciousTrafficExclusionBrandId,
                                                       optionsCaption: 'Select a brand'"></select>
                                </div>

                                <div class="form-group">
                                    <label class="form-label" for="suspicious-traffic-date">Date</label>
                                    <input id="suspicious-traffic-date"
                                           class="input-text"
                                           type="date"
                                           data-bind="value: suspiciousTrafficExclusionDate,
                                                      attr: { min: suspiciousTrafficVariantsStartDate }" />
                                </div>
                            </div>

                            <div class="traffic-settings-saved">
                                <div class="traffic-settings-section-header">
                                    <span class="form-label">Saved exclusions</span>
                                    <span class="traffic-settings-count"
                                          data-bind="text: suspiciousTrafficExclusions().length"></span>
                                </div>

                                <div class="traffic-settings-table-wrap"
                                     data-bind="visible: suspiciousTrafficExclusions().length > 0">
                                    <table class="traffic-settings-table">
                                        <thead>
                                            <tr>
                                                <th>Brand</th>
                                                <th>Date</th>
                                                <th class="traffic-settings-action"><span class="visually-hidden">Actions</span></th>
                                            </tr>
                                        </thead>
                                        <tbody data-bind="foreach: suspiciousTrafficExclusions">
                                            <tr>
                                                <td><span data-bind="text: brandShortName || brandName"></span></td>
                                                <td><span data-bind="text: dateData"></span></td>
                                                <td class="traffic-settings-action">
                                                    <button class="btn icon i-delete traffic-settings-delete"
                                                            type="button"
                                                            title="Remove exclusion"
                                                            aria-label="Remove exclusion"
                                                            data-bind="click: $parent.deleteSuspiciousTrafficExclusion, disable: $parent.suspiciousTrafficSettingsLoading"></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="traffic-settings-empty"
                                     data-bind="visible: suspiciousTrafficExclusions().length === 0">
                                    <span>No saved exclusions</span>
                                    <small>New overrides will appear here.</small>
                                </div>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button class="btn"
                                    type="button"
                                    data-bind="click: closeSuspiciousTrafficSettings">
                                Cancel
                            </button>
                            <button class="btn highlight"
                                    type="button"
                                    data-bind="click: saveSuspiciousTrafficExclusion, disable: suspiciousTrafficSettingsLoading">
                                Save Exclusion
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('gp_sheet');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setFilterContainerClass('margin-neg');
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLogoEnabled(true);

        this.segmentsFilter = new multipleSelector_template("segmentsFilter", this.getTemplateViewModel(), this.caller);
        this.segmentsFilter.setLabel("segments");
        this.segmentsFilter.setFilterContainerClass('margin-neg');
        this.segmentsFilter.setTagContainerId('selected-segments');
        this.segmentsFilter.setTagContainerCaption('Selected segments:');

        this.countriesFilter = new multipleSelector_template("countriesFilter", this.getTemplateViewModel(), this.caller);
        this.countriesFilter.setLabel("countries");
        this.countriesFilter.setFilterContainerClass('margin-neg');
        this.countriesFilter.setTagContainerId('selected-countries');
        this.countriesFilter.setTagContainerCaption('Selected countries:');

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{
            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportDailyDataCsv = new exportDataCsv();

        if (this.l3dSessionsTooltip === undefined){

            this.l3dSessionsTooltip = new infoButton_template('toolTipL3dActiveSessions', this.getTemplateViewModel(), this.caller)
            this.l3dSessionsTooltip.setTitle('L3D Sessions');
        }

        let l3dSessionTooltipContent = "<p>Sessions to new articles published within the last three days.</p>";
        this.l3dSessionsTooltip.setContent(l3dSessionTooltipContent);

        if (this.l7dSessionsTooltip === undefined){

            this.l7dSessionsTooltip = new infoButton_template('toolTipl7dActiveSessions', this.getTemplateViewModel(), this.caller)
            this.l7dSessionsTooltip.setTitle('L7D Sessions');
        }

        let l7dSessionTooltipContent = "<p>Sessions to new articles published within the last seven days.</p>";
        this.l7dSessionsTooltip.setContent(l7dSessionTooltipContent);

        if (this.l30dSessionsTooltip === undefined){

            this.l30dSessionsTooltip = new infoButton_template('toolTipL30dActiveSessions', this.getTemplateViewModel(), this.caller)
            this.l30dSessionsTooltip.setTitle('L30D Sessions');
        }

        let l30dSessionTooltipContent = "<p>Sessions to new articles published within the last thirty days.</p>";
        this.l30dSessionsTooltip.setContent(l30dSessionTooltipContent);

        if (this.displayFillrateTooltip === undefined){

            this.displayFillrateTooltip = new infoButton_template('toolTipDisplayFillrate', this.getTemplateViewModel(), this.caller)
            this.displayFillrateTooltip.setTitle('Display Fillrate');
        }

        let displayFillrateTooltipContent = "<p>Display fill rate = display impressions/ display requests</p>";
        this.displayFillrateTooltip.setContent(displayFillrateTooltipContent);

        if (this.videoFillrateTooltip === undefined){

            this.videoFillrateTooltip = new infoButton_template('toolTipVideoFillrate', this.getTemplateViewModel(), this.caller)
            this.videoFillrateTooltip.setTitle('Video Fillrate');
        }

        let videoFillrateTooltipContent = "<p>Video fill rate = video impressions/ video requests</p>";
        this.videoFillrateTooltip.setContent(videoFillrateTooltipContent);

        if (this.signUpRatioTooltip === undefined){
            // Keep the tooltip behavior aligned with other metric help buttons in GP headers.
            this.signUpRatioTooltip = new infoButton_template('toolTipSignUpRatio', this.getTemplateViewModel(), this.caller)
            this.signUpRatioTooltip.setTitle('Sign-up Ratio');
        }

        // Explain the runtime formula shown in Site Interactions.
        // Same percent formula in GA4 and Sentinel modes; denominator is non-logged pageviews on the row.
        let signUpRatioTooltipContent = "<p>Sign-up Ratio = (new accounts / non-logged-in pageviews) × 100</p>";
        this.signUpRatioTooltip.setContent(signUpRatioTooltipContent);

        if (this.suspiciousTrafficExclusionsTooltip === undefined){

            this.suspiciousTrafficExclusionsTooltip = new infoButton_template('toolTipSuspiciousTrafficExclusions', this.getTemplateViewModel(), this.caller)
            this.suspiciousTrafficExclusionsTooltip.setTitle('Suspicious Traffic Exclusions');
        }
    }

    protected getTemplateName(): string{
        return "gp_sheet_template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        const viewModeSelected = ko.observable("daily");
        const trafficSource = ko.observable(2);
        const colapsButtonText = ko.observable("expand");
        const colapsVideoRPMButtonText = ko.observable("expand");
        const showPageviewsWithSuspicious = ko.computed(function() {
            const expandButtonText = viewModeSelected() === 'advertisers'
                ? colapsButtonText()
                : colapsVideoRPMButtonText();

            return expandButtonText != 'expand';
        });

        return {
            revenueHeaders                              : ko.observableArray([])
            , directAdvertiserNamesArray                : ko.observableArray([])
            , gpHeaders                                 : ko.observableArray([])
            , revenueColumnsNumber                      : ko.observable()
            , metricColumnsNumberPerZone                : ko.observable(4)
            , rpmColumnsNumber                          : ko.observable(8)
            , cpmColumnsNumber                          : ko.observable(2)
            , gpColumnsNumber                           : ko.observable()
            , gpData                                    : ko.observable([])
            , gpZoneData                                : ko.observable([])
            , gpZoneDataForBrands                       : ko.observable([])
            , outstreamDatesWithNewRatios               : ko.observableArray([])
            , outstreamRatioData                        : ko.observableArray([])
            , gpBrandData                               : ko.observable([])
            , portfolioSubtotal                         : ko.observable([])
            , portfolioSubtotalForZones                 : ko.observable([])
            , allTemplates                              : ko.observableArray()
            , activeTemplates                          : ko.observableArray()
            , legacyTemplates                            : ko.observableArray()
            , gpAggInProgress                           : ko.observableArray()
            , templateSelected                          : ko.observable(null)
            , isDefaultFilters                          : ko.observable(false)
            , selectedTemplateFilter                    : ko.observable()
            , selectedTemplateFilterText                : ko.observable("all")
            , segmentGroups                             : ko.observableArray([])
            , selectedMasterSegments                    : ko.observableArray([])
            , trafficTypes                              : ko.observableArray([])
            , trafficTypeSelected                       : ko.observable("all")
            , trafficTypeSelectedText                   : ko.observable("All")
            , viewModes                                 : ko.observableArray([])
            , zonesModeGrouping                         : ko.observable("daily")
            , viewModeSelected                          : viewModeSelected
            , revenueOptions                            : ko.observableArray([])
            , revenueOptionSelected                     : ko.observable("total_rev")
            , revenueOptionSelectedText                 : ko.observable("Total Revenue")
            , displayModeOptions                        : ko.observableArray([])
            , displayModeSelected                       : ko.observable("date")
            , displayModeSelectedText                   : ko.observable("Date")
            , deviceOptionSelectedText                 : ko.observable("All")
            , deviceOptions                            : ko.observableArray([])
            , deviceOptionSelected                     : ko.observable("all")
            , mobileOsOptions                            : ko.observableArray([])
            , mobileOsOptionSelected                     : ko.observable(null)
            , intentGroupings                            : ko.observableArray([])
            , intentGroupingSelected                     : ko.observable("all")
            , intentGroupingSelectedText                 : ko.observable("All")
            , showDeviceRpm                             : ko.observable(true)
            , showRevenueBreakdown                    : ko.observable(true)
            , hasPortfolioHeaders                      : ko.observable(false)
            , portfolioHeaders                         : ko.observable([])
            , showSimplifyButton                        : ko.observable(false)
            , showSimplifyVideoRPMButton                : ko.observable(true)
            , colapsButtonClass                         : ko.observable("i-expand")
            , colapsButtonText                          : colapsButtonText
            , colapsVideoRPMButtonClass                 : ko.observable("i-expand")
            , colapsVideoRPMButtonText                  : colapsVideoRPMButtonText
            , showPageviewsWithSuspicious               : showPageviewsWithSuspicious
            , viewModeLoading                           : ko.observable(false)
            , showVideoRPMSplit                         : ko.observable(false)
            , trafficSource                             : trafficSource
            , trafficColumnsNumber                      : ko.computed(function() {
                let columns = viewModeSelected() === 'advertisers' ? 4 : 6;
                if (trafficSource() == 2) {
                    columns += showPageviewsWithSuspicious() ? 2 : 1;
                }
                return columns;
            })
            , suspiciousTrafficSettingsOpen             : ko.observable(false)
            , suspiciousTrafficExclusions               : ko.observableArray([])
            , suspiciousTrafficExclusionBrandId         : ko.observable('')
            , suspiciousTrafficExclusionDate            : ko.observable('')
            , suspiciousTrafficSettingsLoading          : ko.observable(false)
            , canManageSuspiciousTrafficExclusions      : ko.observable(false)
            , suspiciousTrafficVariantsStartDate        : ko.observable('')
            , availableBrandsOptions                    : ko.observableArray([])
            , openSuspiciousTrafficSettings             : function(){ huit_neuf_this.openSuspiciousTrafficSettings(); }
            , closeSuspiciousTrafficSettings            : function(){ huit_neuf_this.closeSuspiciousTrafficSettings(); }
            , saveSuspiciousTrafficExclusion            : function(){ huit_neuf_this.saveSuspiciousTrafficExclusion(); }
            , deleteSuspiciousTrafficExclusion          : function(data){ huit_neuf_this.deleteSuspiciousTrafficExclusion(data); }
            , selectedRows                              : ko.observableArray([])
            , onTemplateChange                          : function(data){ huit_neuf_this.onTemplateChange(data); }
            , onDeviceOptionChange                      : function(data){ huit_neuf_this.onDeviceOptionChange(data); }
            , onMobileOsOptionChange                      : function(data){ huit_neuf_this.onMobileOsOptionChange(data); }
            , onIntentGroupingChange                    : function(data){ huit_neuf_this.onIntentGroupingChange(data); }
            , onTrafficTypeChange                       : function(data){ huit_neuf_this.onTrafficTypeChange(data); }
            , onViewModeChange                          : function(data){ huit_neuf_this.onViewModeChange(data); }
            , onDeselectAllTemplate                     : function(){ huit_neuf_this.onDeselectAllTemplate(); }
            , onSegmentSelected                         : function(){ huit_neuf_this.onSegmentSelected(); }
            , onDeselectAllSegments                     : function(){ huit_neuf_this.onDeselectAllSegments(); }
            , onDeselectAllTrafficType                  : function(){ huit_neuf_this.onDeselectAllTrafficType(); }
            , onSelectAllSegmentsInGroup                : function(data){ huit_neuf_this.onSelectAllSegmentsInGroup(data); }
            , onDeselectAllSegmentsInGroup              : function(data){ huit_neuf_this.onDeselectAllSegmentsInGroup(data); }
            , onSelectAllPaidSegments                   : function(){ huit_neuf_this.onSelectAllPaidSegments(); }
            , onColapseYieldRevenue                     : function(){ huit_neuf_this.onColapseYieldRevenue(); }
            , onColapseVideoRPM                         : function(){ huit_neuf_this.onColapseVideoRPM(); }
            , onRevenueOptionChange                     : function(data){ huit_neuf_this.onRevenueOptionChange(data); }
            , onDisplayModeChange                       : function(data){ huit_neuf_this.onDisplayModeChange(data); }
            , refreshData                               : function(data){ huit_neuf_this.refreshData(); }
            , swapNegativeSignForParentheses            : function(data){ return huit_neuf_this.swapNegativeSignForParentheses(data); }
            , formatViewabilityPercent                  : function(value){ return huit_neuf_this.formatViewabilityPercent(value); }
            , getClassNames                             : function(data){ return huit_neuf_this.getClassNames(data); }
            ,sourceDataStatus                           : ko.observableArray([])
            ,sourceDataAllStatus                        : ko.observableArray([])
            ,onToggleTrafficSource                      : function(data, event){ huit_neuf_this.onToggleTrafficSource(data, event);}
            ,onToggleZonesModeGrouping                  : function(data, event){ huit_neuf_this.onToggleZonesModeGrouping(data, event);}
            , onClickRowClick                           : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; }
            ,exportData                                 : function(){ huit_neuf_this.exportData(huit_neuf_this); }
        };
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);
        if (check !== -1) {
            selectedRows.splice(check, 1);
        }else {
            selectedRows.push(index);
        }
        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            //sentinel
            this.getTemplateViewModel().trafficSource(1);
        }else {

            //GA4
            this.getTemplateViewModel().trafficSource(2);
        }

        this.setTemplateFromTrafficSource();
        this.caller.getListData();
    }

    public onToggleZonesModeGrouping(data, event){

        let toggleValue = this.getTemplateViewModel().zonesModeGrouping();

        if (toggleValue == 'daily') {

            //brands
            this.getTemplateViewModel().zonesModeGrouping('brands');
        }else {

            //daily
            this.getTemplateViewModel().zonesModeGrouping('daily');
        }

        this.setTemplateFromZonesModeGrouping();
        this.caller.getListData();
    }

    private setTemplateFromTrafficSource() {

        let toggleValue = this.getTemplateViewModel().trafficSource();
    }

    private setTemplateFromZonesModeGrouping() {

        let toggleValue = this.getTemplateViewModel().zonesModeGrouping();
    }

    public getClassNames(data) {

        let cssClass = "";
        if (this.getTemplateViewModel().viewModeSelected() === 'advertisers' && this.getTemplateViewModel().directAdvertiserNamesArray().indexOf(data.name.toUpperCase()) > -1) {

            cssClass = cssClass +  "icon i-external-source";
        }

        return cssClass;
    }

    public setDirectAdvertiserNamesArray() {

        this.getTemplateViewModel().directAdvertiserNamesArray(this.directAdvertiserNamesArray);
    }

    public getViewModelForRequest(){

        return {
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            trafficType: this.getTemplateViewModel().trafficTypeSelected(),
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            segments: this.getTemplateViewModel().segmentsFilter.selectedItems(),
            intentGrouping: this.getTemplateViewModel().intentGroupingSelected(),
            countries: this.getTemplateViewModel().countriesFilter.selectedItems(),
            template: this.getTemplateViewModel().templateSelected(),
            revenueOption: this.getTemplateViewModel().revenueOptionSelected(),
            deviceOption: this.getTemplateViewModel().deviceOptionSelected(),
            mobileOsOption: this.getTemplateViewModel().mobileOsOptionSelected(),
            displayMode: this.getTemplateViewModel().displayModeSelected(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            trafficSource: this.getTemplateViewModel().trafficSource(),
            zonesModeGrouping: this.getTemplateViewModel().zonesModeGrouping()
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }



    public onClickReorder(value, data, event){

    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){
            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }

        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel("Brands");

    }

    public setAvailableBrandsOptions(brands: any[]): void {
        this.getTemplateViewModel().availableBrandsOptions(brands || []);
    }

    public setCanManageSuspiciousTrafficExclusions(canManage: boolean): void {
        this.getTemplateViewModel().canManageSuspiciousTrafficExclusions(canManage);
    }

    public setSuspiciousTrafficVariantsStartDate(startDate: string): void {
        this.getTemplateViewModel().suspiciousTrafficVariantsStartDate(startDate);
    }

    public setSuspiciousTrafficExclusions(items: any[]): void {
        const exclusions = items || [];
        this.getTemplateViewModel().suspiciousTrafficExclusions(exclusions);

        const tooltipContent = '<p>Suspicious traffic is excluded for:</p><ul>'
            + exclusions.map((item) => '<li class="suspicious-traffic-tooltip-item"><strong class="suspicious-traffic-tooltip-brand">'
                + this.escapeTooltipText(item.brandShortName || item.brandName)
                + '</strong><span class="suspicious-traffic-tooltip-date">— '
                + this.escapeTooltipText(item.dateData)
                + '</span></li>')
                .join('')
            + '</ul>';

        this.suspiciousTrafficExclusionsTooltip.setContent(tooltipContent);
        this.suspiciousTrafficExclusionsTooltip.getTemplateViewModel().visibleContent(tooltipContent);
    }

    private escapeTooltipText(value: any): string {
        const entities = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;',
        };

        return String(value || '').replace(/[&<>"']/g, (character) => entities[character]);
    }

    public openSuspiciousTrafficSettings(): void {
        this.getTemplateViewModel().suspiciousTrafficSettingsOpen(true);
        this.caller.loadSuspiciousTrafficExclusions();
    }

    public closeSuspiciousTrafficSettings(): void {
        this.getTemplateViewModel().suspiciousTrafficSettingsOpen(false);
    }

    public saveSuspiciousTrafficExclusion(): void {
        this.caller.saveSuspiciousTrafficExclusion({
            idBrand: this.getTemplateViewModel().suspiciousTrafficExclusionBrandId(),
            dateData: this.getTemplateViewModel().suspiciousTrafficExclusionDate(),
        });
    }

    public deleteSuspiciousTrafficExclusion(row: any): void {
        this.caller.deleteSuspiciousTrafficExclusion({
            idBrand: row.idBrand,
            dateData: row.dateData,
        });
    }

    public setSegmentsFilterItems(segments){
        this.segmentsFilter.setItems(segments.items);
        this.segmentsFilter.setSelectedItems(segments.selected);
    }

    public setIntentGroupingFilterItems(){

        this.getTemplateViewModel().intentGroupings(this.intentGrouping);
    }

    public setTemplateFilterItems(items){

        let keysToDelete = [];
        let activeTemplates = [];
        let allTemplates = [];
        let legacyTemplates = [];

        let orderedItems = this.mapOrder(items, ['regular-all', 'content-exclusive', 'list-all', 'directory-all', 'directory-amp', 'video-home', 'video-regular', 'video-all', 'thread-home', 'thread-all', 'wiki', 'wikilite', 'home', 'hub', 'category', 'manual', 'regular-tldr', 'list-quickview', 'list-list', 'list-tldr', 'quiz-list', 'quiz-all', 'networth-amp', 'game', 'commerce', 'amp-regular', 'amp-list', 'IA'], 'displayedName');

        let activeGroupItems = ['regular-all', 'content-exclusive', 'list-all', 'directory-all', 'directory-amp', 'video-home', 'video-regular', 'video-all', 'thread-home', 'thread-all', 'wiki', 'wikilite', 'home', 'hub', 'category', 'manual'];

        for(let orderItem of orderedItems){
            if(activeGroupItems.indexOf(orderItem.displayedName) > -1){
                let key  = orderedItems.map(function(e) { return e.displayedName; }).indexOf(orderItem.displayedName);
                keysToDelete.push(key);
                activeTemplates.push(orderItem);

            }
        }

        allTemplates.push({"id" : null, "name" : "all", "displayedName" : "all" });

        for(let i = keysToDelete.length -1; i >= 0; i--)
            orderedItems.splice(keysToDelete[i],1);


        for(let item of orderedItems){
            legacyTemplates.push(item);
        }

        this.getTemplateViewModel().allTemplates(allTemplates);
        this.getTemplateViewModel().activeTemplates(activeTemplates);
        this.getTemplateViewModel().legacyTemplates(legacyTemplates);
    }

    public setTrafficTypeFilterItems(){
        this.getTemplateViewModel().trafficTypes(this.trafficTypeFiltersList);
    }

    public setRevenueOptionsFilterItems(){
        this.getTemplateViewModel().revenueOptions(this.revenueOptions);
    }

    public setDisplayModeOptionsFilterItems(){
        this.getTemplateViewModel().displayModeOptions(this.displayModes);
    }

    public setViewModesItems(){
        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setDeviceOptionsFilterItems(){
        this.getTemplateViewModel().deviceOptions(this.deviceOptions);
    }

    public setMobileOsOptionsFilterItems(){
        this.getTemplateViewModel().mobileOsOptions(this.mobileOsOptions);
    }

    public setHeaders(revenueHeaders: Array<object> = [], gpHeaders: Array<object> = [], portfolioHeaders: Array<object>){
        this.getTemplateViewModel().revenueHeaders(revenueHeaders);
        this.getTemplateViewModel().gpHeaders(gpHeaders);
        this.getTemplateViewModel().gpColumnsNumber(gpHeaders.length + 1);

        if (portfolioHeaders.length) {

            this.getTemplateViewModel().hasPortfolioHeaders(true);
            this.getTemplateViewModel().portfolioHeaders(portfolioHeaders);
        }else {

            this.getTemplateViewModel().hasPortfolioHeaders(false);
            this.getTemplateViewModel().portfolioHeaders([]);
        }

        if(this.getTemplateViewModel().viewModeSelected() == 'advertisers'){

            this.getTemplateViewModel().revenueColumnsNumber(revenueHeaders.length + 2);
            this.ajusteRevenueColumnsNumber();
        }

    }

    public setGpData(gpData){

        this.getTemplateViewModel().gpData(gpData);
    }

    public setGpZoneData(gpZoneData){

        this.getTemplateViewModel().gpZoneData(gpZoneData);
    }

    public setGpZoneDataForBrands(gpZoneDataForBrands){

        this.getTemplateViewModel().gpZoneDataForBrands(gpZoneDataForBrands);
    }

    public setOutstreamRatioData(outstreamRatioData){

        this.getTemplateViewModel().outstreamRatioData(outstreamRatioData);

        let outstreamDatesWithNewRatios = [];
        for (let ratio of outstreamRatioData) {

            if (ratio.isRatioDate) {

                outstreamDatesWithNewRatios[ratio.date] = true;
            }
        }

        this.getTemplateViewModel().outstreamDatesWithNewRatios(outstreamDatesWithNewRatios);
    }

    public setBrandGpData(gpBrandData){

        this.getTemplateViewModel().gpBrandData(gpBrandData);
    }

    public setPortfolioSubtotal(portfolioSubtotal){

        this.getTemplateViewModel().portfolioSubtotal(portfolioSubtotal);
    }

    public setPortfolioSubtotalForZones(portfolioSubtotal){

        this.getTemplateViewModel().portfolioSubtotalForZones(portfolioSubtotal);
    }

    private getTemplateFromName(name){

        let templates = this.getTemplateViewModel().allTemplates().concat(this.getTemplateViewModel().activeTemplates(), this.getTemplateViewModel().legacyTemplates());
        let element = templates.filter((t) => (t.name == name));
        let template = element.shift();

        if (template){

            this.getTemplateViewModel().templateSelected(template);
        }

        return template;
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void {

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.segmentsFilter, params['segments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.countriesFilter, params['countries']);

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);

            if(params['viewMode'] == 'advertisers'){

                this.getTemplateViewModel().colapsButtonClass("i-expand");
                this.getTemplateViewModel().colapsButtonText("expand");

                this.getTemplateViewModel().showSimplifyButton(true);
                this.getTemplateViewModel().showSimplifyVideoRPMButton(false);
            }else{

                this.getTemplateViewModel().showSimplifyButton(false);
                this.getTemplateViewModel().showSimplifyVideoRPMButton(true);
            }
        }

        if(typeof params['template'] !== 'undefined'){

            let template = this.getTemplateFromName(params['template']);

            this.getTemplateViewModel().selectedTemplateFilter(template.id);
            this.getTemplateViewModel().templateSelected(template.name);
            this.getTemplateViewModel().selectedTemplateFilterText(template.displayedName);

        }

        if(typeof params['trafficType'] !== 'undefined'){


            this.getTemplateViewModel().trafficTypeSelected(params['trafficType']);
            this.getTemplateViewModel().trafficTypeSelectedText(this.presetFilter.getFilterTextFromId(this.trafficTypeFiltersList, params['trafficType']));
        }

        if(typeof params['intentGrouping'] !== 'undefined'){

            this.getTemplateViewModel().intentGroupingSelected(params['intentGrouping']);
            this.getTemplateViewModel().intentGroupingSelectedText(this.presetFilter.getFilterTextFromId(this.intentGrouping, params['intentGrouping']));
        }

        if(typeof params['revenueOption'] !== 'undefined'){

            this.getTemplateViewModel().revenueOptionSelected(params['revenueOption']);
            this.getTemplateViewModel().revenueOptionSelectedText(this.presetFilter.getFilterTextFromId(this.revenueOptions, params['revenueOption']));
        }

        if(typeof params['deviceOption'] !== 'undefined'){

            this.getTemplateViewModel().mobileOsOptionSelected(null);
            this.getTemplateViewModel().deviceOptionSelected(params['deviceOption']);
            this.getTemplateViewModel().deviceOptionSelectedText(this.presetFilter.getFilterTextFromId(this.deviceOptions, params['deviceOption']));


            if(params['deviceOption'] == 'all'){
                this.getTemplateViewModel().showDeviceRpm(true);
            }else{
                this.getTemplateViewModel().showDeviceRpm(false);
            }

        }

        if(typeof params['mobileOsOption'] !== 'undefined'){

            this.getTemplateViewModel().deviceOptionSelected(null);
            this.getTemplateViewModel().mobileOsOptionSelected(params['mobileOsOption']);
            this.getTemplateViewModel().deviceOptionSelectedText(this.presetFilter.getFilterTextFromId(this.mobileOsOptions, params['mobileOsOption']));

        }

        if(typeof params['displayMode'] !== 'undefined'){

            this.getTemplateViewModel().displayModeSelected(params['displayMode']);
            this.getTemplateViewModel().displayModeSelectedText(this.presetFilter.getFilterTextFromId(this.displayModes, params['displayMode']));
        }

        if(typeof params['trafficSource'] !== 'undefined'){

            this.getTemplateViewModel().trafficSource(params['trafficSource']);
            this.setTemplateFromTrafficSource();
        }

        if(typeof params['zonesModeGrouping'] !== 'undefined'){

            this.getTemplateViewModel().zonesModeGrouping(params['zonesModeGrouping']);
            this.setTemplateFromZonesModeGrouping();
        }

        if(this.getTemplateViewModel().viewModeSelected() == 'advertisers' || this.getTemplateViewModel().revenueOptionSelected() == 'rpm_count' || this.getTemplateViewModel().revenueOptionSelected() == 'rev_percentage' || this.getTemplateViewModel().revenueOptionSelected() == 'inventory' || this.getTemplateViewModel().revenueOptionSelected() == "inv_percentage" ){
            this.getTemplateViewModel().showRevenueBreakdown(false);
        }else{
            this.getTemplateViewModel().showRevenueBreakdown(true);
        }

        this.processColumnCounts();
    }

    private onTemplateChange(selectedTemplateOption){

        this.getTemplateViewModel().selectedTemplateFilterText(selectedTemplateOption.displayedName);


        this.getTemplateViewModel().colapsButtonClass("i-expand");
        this.getTemplateViewModel().colapsButtonText("expand");
        this.caller.getListData();
    }

    private onViewModeChange(selectedTemplate){

        // We collapse things if they were expanded before switching view mode to avoid weird errors and mismatched numbers of columns.
        if (this.getTemplateViewModel().colapsButtonText() == 'simplify'){

            this.onColapseYieldRevenue();
        }

        let selectedRevenueOption = this.getTemplateViewModel().revenueOptionSelected();
        if(selectedTemplate.name == 'advertisers' || selectedRevenueOption == 'rpm_count' || selectedRevenueOption == 'rev_percentage' || selectedRevenueOption == 'inventory' || selectedRevenueOption == "inv_percentage" ){
            this.getTemplateViewModel().showRevenueBreakdown(false);
        }else{
            this.getTemplateViewModel().showRevenueBreakdown(true);
        }

        if(selectedTemplate.name == 'advertisers'){

            this.getTemplateViewModel().showSimplifyButton(true);
            this.getTemplateViewModel().showSimplifyVideoRPMButton(false);
        }else{

            this.getTemplateViewModel().showSimplifyButton(false);
            this.getTemplateViewModel().showSimplifyVideoRPMButton(true);
        }

        this.caller.getListData();
    }

    private onDeselectAllTemplate(){
        this.getTemplateViewModel().templateSelected(null);
        this.caller.getListData();
    }

    private onSelectAllSegmentsInGroup(data){

        data.selectedItems([]);
        for(let item of data.items){
            data.selectedItems.push(item.id);
        }

        this.caller.getListData();
    }

    private onSelectAllPaidSegments(){

        let allSegmentGroups = this.getTemplateViewModel().segmentGroups();

        for(let segmentGroup of allSegmentGroups){
            segmentGroup.selectedItems([]);
            if(segmentGroup.id != 'organic_seg'){
                for(let item of segmentGroup.items){
                    segmentGroup.selectedItems.push(item.id);
                }
            }
        }
        this.caller.getListData();
    }

    private onDeselectAllSegmentsInGroup(data){

        data.selectedItems([]);
        this.caller.getListData();
    }

    private onSegmentSelected(){

        this.caller.getListData();

    }

    private onRevenueOptionChange(selectedRevenueOption){
        this.getTemplateViewModel().revenueOptionSelectedText(selectedRevenueOption.name);

        let selectedViewMode = this.getTemplateViewModel().viewModeSelected();

        if(selectedViewMode == 'advertisers' || selectedRevenueOption.id == 'rpm_count' || selectedRevenueOption.id == 'rev_percentage' || selectedRevenueOption.id == 'inventory' || selectedRevenueOption.id == 'inv_percentage'){
            this.getTemplateViewModel().showRevenueBreakdown(false);
        }else{
            this.getTemplateViewModel().showRevenueBreakdown(true);
        }

        this.caller.getListData();
    }

    private processColumnCounts(){

        let rpmColumnsNumber = 6;
        let zoneMetricsNumber = 4;

        if  (this.getTemplateViewModel().colapsVideoRPMButtonText() != 'expand') {

            rpmColumnsNumber = rpmColumnsNumber + 4;
            zoneMetricsNumber = zoneMetricsNumber + 5;
        }


        if(this.getTemplateViewModel().deviceOptionSelectedText() == 'All'){

            this.getTemplateViewModel().showDeviceRpm(true);
            rpmColumnsNumber = rpmColumnsNumber + 2;
        }else {

            this.getTemplateViewModel().showDeviceRpm(false);
        }

        if(this.getTemplateViewModel().showVideoRPMSplit()){

            rpmColumnsNumber = rpmColumnsNumber + 1;
        }

        this.getTemplateViewModel().rpmColumnsNumber(rpmColumnsNumber);
        this.getTemplateViewModel().metricColumnsNumberPerZone(zoneMetricsNumber);

    }
    private onDeviceOptionChange(selectedDeviceOption){

        this.getTemplateViewModel().mobileOsOptionSelected(null);

        this.getTemplateViewModel().deviceOptionSelectedText(selectedDeviceOption.name);

        this.processColumnCounts();

        this.caller.getListData();
    }

    private onMobileOsOptionChange(selectedMobileOsOption){

        this.getTemplateViewModel().deviceOptionSelected(null);

        this.getTemplateViewModel().deviceOptionSelectedText(selectedMobileOsOption.name);

        this.caller.getListData();
    }

    private onIntentGroupingChange(selectedIntentGrouping){

        this.getTemplateViewModel().intentGroupingSelectedText(selectedIntentGrouping.name);
        this.caller.getListData();
    }

    private onDisplayModeChange(selectedDisplayMode){

        this.getTemplateViewModel().displayModeSelectedText(selectedDisplayMode.name);
        this.caller.getListData();
    }

    private onDeselectAllSegments(){

        let segmentGroups = this.getTemplateViewModel().segmentGroups();
        for(let segmentGroup of segmentGroups){
            segmentGroup.selectedItems([]);
        }
        this.caller.getListData();
    }

    private onTrafficTypeChange(selectedTrafficTypeOption){
        this.getTemplateViewModel().trafficTypeSelectedText(selectedTrafficTypeOption.name);

        this.caller.getListData();
    }

    private onViewModesChange(){
        this.caller.getListData();
    }

    private onDeselectAllTrafficType(){
        this.getTemplateViewModel().trafficTypeSelected(null);
        this.caller.getListData()
    }

    private refreshData(){
        this.caller.getListData();
    }


    private mapOrder (array, order, key) {

        array.sort( function (a, b) {
            var A = a[key], B = b[key];

            if (order.indexOf(A) > order.indexOf(B)) {
                return 1;
            } else {
                return -1;
            }

        });

        return array;
    };

    private onColapseYieldRevenue(){

        let revenueHeaders = this.getTemplateViewModel().revenueHeaders();
        let revenueColumnsNumber = this.getTemplateViewModel().revenueColumnsNumber();

        if(this.getTemplateViewModel().colapsButtonText() == 'simplify'){

            for(let revenueHeader of revenueHeaders){
                if(revenueHeader.type == 'yield_partner' || revenueHeader.name.indexOf('ValStream_') !== -1){
                    revenueColumnsNumber = revenueColumnsNumber - 1;
                }
            }

            // The extra 2 columns are the ValStream and Exchange bidding columns.
            revenueColumnsNumber = revenueColumnsNumber + 2;
            this.getTemplateViewModel().colapsButtonClass('i-expand');
            this.getTemplateViewModel().colapsButtonText('expand');

        }else{
            for(let revenueHeader of revenueHeaders){
                if(revenueHeader.type == 'yield_partner' || revenueHeader.name.indexOf('ValStream_') !== -1){
                    revenueColumnsNumber = revenueColumnsNumber + 1;
                }
            }

            // The extra 2 columns are the ValStream and Exchange bidding columns.
            revenueColumnsNumber = revenueColumnsNumber - 2;
            this.getTemplateViewModel().colapsButtonClass('i-simplify');
            this.getTemplateViewModel().colapsButtonText('simplify');
        }

        this.getTemplateViewModel().revenueColumnsNumber(revenueColumnsNumber);
    }

    private onColapseVideoRPM(){

        if(this.getTemplateViewModel().colapsVideoRPMButtonText() == 'simplify'){

            this.getTemplateViewModel().showVideoRPMSplit(false);

            this.getTemplateViewModel().colapsVideoRPMButtonClass('i-expand');
            this.getTemplateViewModel().colapsVideoRPMButtonText('expand');

        }else{

            this.getTemplateViewModel().showVideoRPMSplit(true);

            this.getTemplateViewModel().colapsVideoRPMButtonClass('i-simplify');
            this.getTemplateViewModel().colapsVideoRPMButtonText('simplify');

        }

        this.processColumnCounts();
    }

    private ajusteRevenueColumnsNumber(){

        if(this.getTemplateViewModel().colapsButtonText() != 'simplify'){

            let revenueHeaders = this.getTemplateViewModel().revenueHeaders();
            let revenueColumnsNumber = this.getTemplateViewModel().revenueColumnsNumber();
            for(let revenueHeader of revenueHeaders){
                if(revenueHeader.type == 'yield_partner' || revenueHeader.name.indexOf('ValStream_') !== -1){
                    revenueColumnsNumber = revenueColumnsNumber - 1;
                }
            }

            // The extra 2 columns are the ValStream and Exchange bidding columns.
            revenueColumnsNumber = revenueColumnsNumber + 2;
            this.getTemplateViewModel().revenueColumnsNumber(revenueColumnsNumber);
        }
    }

    public setGpAggInProgress(items){
        this.getTemplateViewModel().gpAggInProgress(items);
    }

    public setIsDefaultFilters(isDefaultFilters){
        this.getTemplateViewModel().isDefaultFilters(isDefaultFilters);
    }

    public setCountriesFilterItems(groupedCountries){

        this.countriesFilter.setMultiSectionItems(groupedCountries);
        this.countriesFilter.setLabel('Countries');
    }

    public swapNegativeSignForParentheses(value: string){

        if (value.length > 1 && value.substring(0,1) === '-'){

            let valueFloat = parseFloat(value);
            if (valueFloat < 0){

                // Remove the negative sign at the begining of the string and swap it for parentheses
                value = '(' + value.substring(1) + ')';
            }
            else{

                // Sometime we get a value like -0.00 because we only display x digits after the decimal, so here we just remove the negative without adding the parentheses.
                value = value.substring(1);
            }
        }

        return value;
    }

    public formatViewabilityPercent(value: number | null | undefined): string {

        if (value === null || value === undefined || typeof value !== 'number' || Number.isNaN(value)) {

            return '—';
        }

        return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }

    private exportData(obj){

        switch(this.getTemplateViewModel().viewModeSelected()){
            case "daily": {

                this.exportDailyData(obj)
                break;
            }
            case "brands": {

                this.exportBrandsData(obj)
                break;
            }
            case "segments": {

                break;
            }
            case "templates": {

                break;
            }
            case "advertisers": {

                this.exportAdvertisersData(obj);
                break;
            }
        }
    }

    private exportDailyData(obj){

        let data = [];
        for (let gpDataRow of this.getTemplateViewModel().gpData()){

            let element = {};
            element['Date'] = gpDataRow['date'];

            let portforlioCount = 0;
            for (let row of gpDataRow.revenueData){

                let metricValue = 'N/A';
                switch (this.getTemplateViewModel().revenueOptionSelected()){

                    case 'total_rev': {

                        metricValue = Number(row.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        break;
                    }
                    case 'rpm_count': {

                        metricValue = Number(row.revenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        break;
                    }
                    case 'rev_percentage': {

                        metricValue = Number(row.revenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        break;
                    }
                    case 'inventory': {

                        metricValue = Number(row.impressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                        break;
                    }
                    case 'inv_percentage': {

                        metricValue = Number(row.impressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        break;
                    }
                }

                if (row.headerType !== undefined && row.headerType == 'brand'){

                    element[row.headerName] = metricValue;
                }else{

                    element[this.getTemplateViewModel().portfolioHeaders()[portforlioCount++].name + ' Total'] = metricValue;
                }
            }

            element = this.getTotals(element, gpDataRow, true);
            element = this.addOtherDataToElement(element, gpDataRow, true, true, true, true, true);

            data.push(element);
        }

        let fileName = "revenue_sheet_daily_data_" + this.getTemplateViewModel().revenueOptionSelected() + "_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportDailyDataCsv.exportToCsv(fileName, data);
    }

    private exportBrandsData(obj){

        let data = [];
        for (let gpDataRow of this.getTemplateViewModel().gpBrandData()){

            let element = {};

            element['Portoflio'] = gpDataRow.sideHeaders.portfolio.name;
            element['Brand'] = gpDataRow.sideHeaders.brand.shortName;

            if (gpDataRow.data !== undefined){

                // Regular brand row (and total)
                element = this.getTotals(element, gpDataRow.data, true);
                element = this.addOtherDataToElement(element, gpDataRow.data, true, true, true, true, true);
            } else{

                // Portfolio sub total
                for(let potfolioSubtotal of this.getTemplateViewModel().portfolioSubtotal()){

                    if(potfolioSubtotal.idPortfolio == gpDataRow.sideHeaders.portfolio.id){

                        element = this.getTotals(element, potfolioSubtotal, true);
                        element = this.addOtherDataToElement(element, potfolioSubtotal, true, true, true, true, true);
                    }
                }
            }

            data.push(element);
        }

        let fileName = "revenue_sheet_daily_data_" + this.getTemplateViewModel().revenueOptionSelected() + "_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportDailyDataCsv.exportToCsv(fileName, data);
    }

    private exportAdvertisersData(obj){

        let data = [];
        for (let gpDataRow of this.getTemplateViewModel().gpData()){

            let element = {};
            element['Date'] = gpDataRow['date'];

            let portforlioCount = 0;
            for (let row of gpDataRow.revenueData){

                let metricValue = this.getMetricValueForRevenueOption(row);
                element[row.headerName] = metricValue;
            }

            // You might be wondering where there's duplcation here. There is a bug where only revenue is displayed even when a different revenue option is selected (like inventory or percentage). This will be fixed in another task. Don't forget to also fix the UI when you fix it.
            switch (this.getTemplateViewModel().revenueOptionSelected()){

                case 'total_rev': {

                    element['VAL-IN'] = Number(gpDataRow.videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT'] = Number(gpDataRow.videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT2'] = Number(gpDataRow.videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-COMP'] = Number(gpDataRow.videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    break;
                }
                case 'rpm_count': {

                    element['VAL-IN'] = Number(gpDataRow.videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT'] = Number(gpDataRow.videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT2'] = Number(gpDataRow.videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-COMP'] = Number(gpDataRow.videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    break;
                }
                case 'rev_percentage': {

                    element['VAL-IN'] = Number(gpDataRow.videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT'] = Number(gpDataRow.videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT2'] = Number(gpDataRow.videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-COMP'] = Number(gpDataRow.videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    break;
                }
                case 'inventory': {

                    element['VAL-IN'] = Number(gpDataRow.videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT'] = Number(gpDataRow.videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT2'] = Number(gpDataRow.videoImpressionsOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-COMP'] = Number(gpDataRow.videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    break;
                }
                case 'inv_percentage': {

                    element['VAL-IN'] = Number(gpDataRow.videoRevenueInstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT'] = Number(gpDataRow.videoRevenueOutstream).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-OUT2'] = Number(gpDataRow.videoRevenueOutstream2).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['VAL-COMP'] = Number(gpDataRow.videoRevenueCompanion).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    break;
                }
            }

            element = this.getTotals(element, gpDataRow, false);
            element = this.addOtherDataToElement(element, gpDataRow, true, true, true, false, false);

            data.push(element);
        }

        let fileName = "revenue_sheet_advertisers_data_" + this.getTemplateViewModel().revenueOptionSelected() + "_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportDailyDataCsv.exportToCsv(fileName, data);
    }

    private getMetricValueForRevenueOption(row){

        let metricValue = 'N/A';
        switch (this.getTemplateViewModel().revenueOptionSelected()){

            case 'total_rev': {

                metricValue = Number(row.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                break;
            }
            case 'rpm_count': {

                metricValue = Number(row.revenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                break;
            }
            case 'rev_percentage': {

                metricValue = Number(row.revenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                break;
            }
            case 'inventory': {

                metricValue = Number(row.impressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                break;
            }
            case 'inv_percentage': {

                metricValue = Number(row.impressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                break;
            }
        }

        return metricValue;
    }

    private getTotals(element, row, includeRevenueBreakdown){

        switch (this.getTemplateViewModel().revenueOptionSelected()){

            case 'total_rev': {

                element['Total'] = Number(row.totalRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

                if(includeRevenueBreakdown){

                    element['Revenue: Prog.'] = Number(row.programmaticRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Aff.'] = Number(row.affiliateRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Direct'] = Number(row.directRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Dir. Display'] = Number(row.directDisplayRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Dir. Video'] = Number(row.directVideoRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Spon.'] = Number(row.sponsoredRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Soc. & Vid.'] = Number(row.socialRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Premium'] = Number(row.premiumRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Marketplace'] = Number(row.marketplaceRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: MP AFF.'] = Number(row.marketplaceAffiliateRevenue ?? 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: MP Placed'] = Number(row.marketplacePlacedRevenue ?? 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    element['Revenue: Leadgen Total'] = Number(row.leadgenRevenueTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
                break;
            }
            case 'rpm_count': {

                element['Total'] = Number(row.totalRevenueRpmCnt).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                break;
            }
            case 'rev_percentage': {

                element['Total'] = Number(row.totalRevenuePercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                break;
            }
            case 'inventory': {

                element['Total'] = Number(row.totalImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                break;
            }
            case 'inv_percentage': {

                element['Total'] = Number(row.totalImpressionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});;
                break;
            }
        }

        return element;
    }

    private addOtherDataToElement(element, row, includeRpm, includeSv, includeTraffic, includeImpressions, includeSiteInteraction){

        // Other data
        if(includeRpm){

            element['RPM: Disp.'] = Number(row.bannerRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Disp. RPM30'] = Number(row.bannerRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Vid.'] = Number(row.videoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Vid. RPM30'] = Number(row.videoRpm30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

            if (this.getTemplateViewModel().viewModeSelected() == 'brands'){

                element['RPM: Out1'] = 'N/A';
                // element['RPM: Out2'] = 'N/A';
            } else{

                element['RPM: Out1'] = Number(row.videoOutstreamRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                // element['RPM: Out2'] = Number(row.videoOutstream2Rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            }

            element['RPM: Aff.'] = Number(row.affiliateRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Direct'] = Number(row.directRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Dir. Display'] = Number(row.directDisplayRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Dir. Video'] = Number(row.directVideoRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Spon.'] = Number(row.sponsoredRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Desktop'] = Number(row.desktopRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Mobile'] = Number(row.mobileRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['RPM: Total'] = Number(row.rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        element['CPM: Display'] = Number(row.displayCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        element['CPM: Video'] = Number(row.videoCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        if(includeSv){

            element['SV: Prog.'] = Number(row.sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['SV: Total'] = Number(row.totalSv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if(includeTraffic){

            element['Traffic: Sessions'] = Number(row.sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            // element['Traffic: L3D Sessions'] = Number(row.l3dSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            // element['Traffic: L7D Sessions'] = Number(row.l7dSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            // element['Traffic: L30D Sessions'] = Number(row.l30dSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            element['Traffic: Pageviews'] = Number(row.pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            if (this.getTemplateViewModel().trafficSource() == 2) {
                element['Traffic: Pageviews (No Susp.)'] = Number(row.pageviewsWithoutSuspicious || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Traffic: Pageviews (W/ Susp.)'] = Number(row.pageviewsWithSuspicious || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            }
            element['Traffic: US%'] = Number(row.sessionsUSPercent).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';

            if (this.getTemplateViewModel().viewModeSelected() != 'advertisers' ){

                element['Traffic: PG/S'] = Number(row.pgs).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            }

            element['Traffic: iOS/Android'] = row.ios_android_sessions;

            if (this.getTemplateViewModel().viewModeSelected() != 'advertisers' ){

                element['Traffic: Instream Views'] = Number(row.instreamViews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            }
        }

        if(includeImpressions){

            element['Imp & Req: Disp. Imp/Sess'] = Number(row.banner_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Disp. Fillrate'] = Number(row.banner_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            element['Imp & Req: Disp. Imp % Dir'] = Number(row.banner_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            element['Imp & Req: Disp. Imp'] = Number(row.bannerImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            element['Imp & Req: Disp. ImpP30'] = Number(row.bannerImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Disp. Req/Sess'] = Number(row.banner_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Disp. Requests'] = Number(row.banner_requests).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            element['Imp & Req: Disp. ReqP30'] = Number(row.banner_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Disp. Bid Req/Sess'] = Number(row.banner_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Vid. Imp/Sess'] = Number(row.video_imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Vid. Fillrate'] = Number(row.video_fillrate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            element['Imp & Req: Vid. Imp % Dir'] = Number(row.video_imp_pct_direct).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            element['Imp & Req: Vid. Imp'] = Number(row.videoImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            element['Imp & Req: Vid. ImpP30'] = Number(row.videoImpressionsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Vid. Req/Sess'] = Number(row.video_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Vid. Req'] = Number(row.video_requests).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            element['Imp & Req: Vid. ReqP30'] = Number(row.video_requestsP30).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Vid. Bid Req/Sess'] = Number(row.video_bid_req_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            element['Imp & Req: Viewability'] = (row.viewability === null || row.viewability === undefined || typeof row.viewability !== 'number' || Number.isNaN(row.viewability))
                ? ''
                : Number(row.viewability).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            element['Imp & Req: Total Imp'] = Number(row.bannerImpressions + row.videoImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            element['Imp & Req: Total Req'] = Number(row.banner_requests + row.video_requests).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

            element['Imp & Req: Total'] = Number(row.imp_per_session).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().isDefaultFilters()){

            // Adblock Recovery
            if (this.getTemplateViewModel().trafficSource() == 2){

                element['Adblock Recovery: Revenue'] = Number(row.adblockRecoveryRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                element['Adblock Recovery: Pageviews'] = Number(row.adblockRecoveryPageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Adblock Recovery: Sessions'] = Number(row.adblockRecoverySessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Adblock Recovery: RPM'] = Number(row.adblockRecoveryRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                element['Adblock Recovery: RPM Display'] = Number(row.adblockRecoveryRpmDisplay).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                element['Adblock Recovery: RPM Video'] = Number(row.adblockRecoveryRpmVideo).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                element['Adblock Recovery: RPM Desktop'] = Number(row.adblockRecoveryRpmDesktop).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                element['Adblock Recovery: RPM Mobile'] = Number(row.adblockRecoveryRpmMobile).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                element['Adblock Recovery: SV'] = Number(row.adblockRecoverySv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            }
            else{

                element['Adblock Recovery: Revenue'] = 'N/A';
                element['Adblock Recovery: Pageviews'] = 'N/A';
                element['Adblock Recovery: Sessions'] = 'N/A';
                element['Adblock Recovery: RPM'] = 'N/A';
                element['Adblock Recovery: RPM Display'] = 'N/A';
                element['Adblock Recovery: RPM Video'] = 'N/A';
                element['Adblock Recovery: RPM Desktop'] = 'N/A';
                element['Adblock Recovery: RPM Mobile'] = 'N/A';
                element['Adblock Recovery: SV'] = 'N/A';
            }

            if(includeSiteInteraction){

                element['Site Int.: Prem. Users'] = Number(row.newPremiumUsers).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Site Int.: Prem. Unsubs'] = Number(row.premiumUserUnsubs).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Site Int.: Email Subs'] = Number(row.newsletterUniqueSubscribers).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Site Int.: Reg. Users'] = Number(row.newMembers).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
                element['Site Int.: Logged-in PV'] = Number(row.loggedInPageviews_per_pageviews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                // Keep sign-up ratio export explicit as percent of non-logged pageviews.
                element['Site Int.: Sign-up Ratio'] = Number(row.signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            }
        }

        return element;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/gp_sheet_template.ts